// src/permissions.ts
var PERMISSIONS = {
  // Administration
  USERS_VIEW: "admin.users.view",
  USERS_CREATE: "admin.users.create",
  USERS_UPDATE: "admin.users.update",
  USERS_DEACTIVATE: "admin.users.deactivate",
  USERS_RESET_PASSWORD: "admin.users.resetPassword",
  ROLES_VIEW: "admin.roles.view",
  ROLES_MANAGE: "admin.roles.manage",
  AUDIT_VIEW: "admin.audit.view",
  AUDIT_EXPORT: "admin.audit.export",
  SETTINGS_VIEW: "admin.settings.view",
  SETTINGS_MANAGE: "admin.settings.manage",
  NUMBER_SERIES_MANAGE: "admin.numberSeries.manage",
  JOBS_VIEW: "admin.jobs.view",
  JOBS_MANAGE: "admin.jobs.manage",
  NOTIFICATION_TEMPLATES_MANAGE: "admin.notificationTemplates.manage",
  APPROVAL_RULES_MANAGE: "admin.approvalRules.manage",
  // Shared services
  FILES_UPLOAD: "files.upload",
  FILES_DOWNLOAD: "files.download",
  APPROVALS_VIEW: "approvals.requests.view",
  DATA_IMPORT: "data.import",
  DATA_IMPORT_SIGNOFF: "data.imports.signOff",
  // CRM
  LEADS_VIEW: "crm.leads.view",
  LEADS_VIEW_ALL: "crm.leads.viewAll",
  LEADS_CREATE: "crm.leads.create",
  LEADS_UPDATE: "crm.leads.update",
  LEADS_ASSIGN: "crm.leads.assign",
  LEADS_CONVERT: "crm.leads.convert",
  LEADS_EXPORT: "crm.leads.export",
  ACTIVITIES_LOG: "crm.activities.log",
  FOLLOWUPS_TEAM: "crm.followups.team",
  CUSTOMERS_VIEW: "crm.customers.view",
  CUSTOMERS_CREATE: "crm.customers.create",
  CUSTOMERS_UPDATE: "crm.customers.update",
  CUSTOMERS_EXPORT: "crm.customers.export",
  PARTNERS_VIEW: "crm.partners.view",
  PARTNERS_MANAGE: "crm.partners.manage",
  // Projects & sites
  PROJECTS_VIEW: "projects.projects.view",
  PROJECTS_CREATE: "projects.projects.create",
  PROJECTS_UPDATE: "projects.projects.update",
  PROJECTS_EXPORT: "projects.projects.export",
  // Masters
  MASTERS_VIEW: "masters.all.view",
  MASTERS_MANAGE: "masters.general.manage",
  ITEMS_MANAGE: "masters.items.manage",
  PRICING_MANAGE: "masters.pricing.manage",
  TAX_MANAGE: "masters.tax.manage",
  SUPPLIERS_MANAGE: "masters.suppliers.manage",
  // Proposal Studio
  PROPOSALS_VIEW: "proposals.proposals.view",
  PROPOSALS_VIEW_ALL: "proposals.proposals.viewAll",
  PROPOSALS_EDIT: "proposals.proposals.edit",
  PROPOSALS_APPROVE: "proposals.proposals.approve",
  PROPOSALS_SHARE: "proposals.proposals.share",
  PROPOSALS_PRICE_OVERRIDE: "proposals.pricing.override",
  PROPOSALS_VIEW_COST: "proposals.pricing.viewCost",
  PROPOSAL_TEMPLATES_MANAGE: "proposals.templates.manage",
  // Billing
  QUOTATIONS_VIEW: "billing.quotations.view",
  QUOTATIONS_EDIT: "billing.quotations.edit",
  QUOTATIONS_APPROVE: "billing.quotations.approve",
  INVOICES_VIEW: "billing.invoices.view",
  INVOICES_EDIT: "billing.invoices.edit",
  INVOICES_APPROVE: "billing.invoices.approve",
  INVOICES_POST: "billing.invoices.post",
  RECEIPTS_VIEW: "billing.receipts.view",
  RECEIPTS_CREATE: "billing.receipts.create",
  RECEIPTS_REVERSE: "billing.receipts.reverse",
  LEDGER_VIEW: "billing.ledger.view",
  STATEMENTS_SEND: "billing.statements.send",
  TAX_RULES_MANAGE: "billing.taxRules.manage",
  TAX_RULES_SIGN_OFF: "billing.taxRules.signOff",
  // Inventory & procurement
  INVENTORY_VIEW: "inventory.stock.view",
  INVENTORY_MOVE: "inventory.stock.move",
  INVENTORY_ADJUST: "inventory.stock.adjust",
  INVENTORY_APPROVE: "inventory.stock.approve",
  INVENTORY_VIEW_COST: "inventory.stock.viewCost",
  LOCATIONS_MANAGE: "inventory.locations.manage",
  PROJECT_BOM_MANAGE: "inventory.bom.manage",
  COMPLIANCE_MANAGE: "inventory.compliance.manage",
  PROCUREMENT_VIEW: "procurement.all.view",
  PR_CREATE: "procurement.requests.create",
  PR_APPROVE: "procurement.requests.approve",
  PO_MANAGE: "procurement.orders.manage",
  PO_APPROVE: "procurement.orders.approve",
  GRN_MANAGE: "procurement.receipts.manage",
  // Solar execution, DISCOM and subsidy
  SURVEY_MANAGE: "execution.surveys.manage",
  DESIGN_MANAGE: "execution.designs.manage",
  DESIGN_APPROVE: "execution.designs.approve",
  EXECUTION_MANAGE: "execution.sites.manage",
  CREWS_MANAGE: "execution.crews.manage",
  DPR_CREATE: "execution.dpr.create",
  DPR_SIGN_OFF: "execution.dpr.signOff",
  CHECKLIST_FILL: "execution.checklists.fill",
  CHECKLIST_TEMPLATES_MANAGE: "execution.checklists.manageTemplates",
  DISCOM_MANAGE: "execution.discom.manage",
  SUBSIDY_VIEW: "execution.subsidy.view",
  SUBSIDY_MANAGE: "execution.subsidy.manage",
  PROJECT_CLOSE: "projects.projects.close",
  PROJECT_CLOSE_OVERRIDE: "projects.projects.closeOverride",
  // Telecom operations and collections
  WORK_ORDERS_MANAGE: "telecom.workOrders.manage",
  DISPATCH_MANAGE: "telecom.dispatch.manage",
  DISPATCH_RECEIVE: "telecom.dispatch.receive",
  SITE_COMPLETION_MANAGE: "telecom.completion.manage",
  TELECOM_BILLING_READY: "telecom.billing.ready",
  TELECOM_BILLING: "telecom.billing.invoice",
  COLLECTIONS_MANAGE: "billing.collections.manage",
  // Costs and profitability
  EXPENSES_VIEW: "finance.expenses.view",
  EXPENSES_CREATE: "finance.expenses.create",
  EXPENSES_APPROVE: "finance.expenses.approve",
  LABOUR_MANAGE: "finance.labour.manage",
  LABOUR_APPROVE: "finance.labour.approve",
  REFERRALS_MANAGE: "finance.referrals.manage",
  REFERRALS_APPROVE: "finance.referrals.approve",
  OVERHEADS_MANAGE: "finance.overheads.manage",
  CHANGE_ORDERS_MANAGE: "projects.changeOrders.manage",
  CHANGE_ORDERS_APPROVE: "projects.changeOrders.approve",
  ESTIMATES_MANAGE: "finance.estimates.manage",
  PNL_VIEW: "finance.pnl.view",
  // AI
  AI_USE: "ai.features.use",
  AI_MANAGE: "admin.ai.manage",
  AI_COPILOT: "ai.copilot.use"
};
var meta = (key, module, label, description) => ({
  key,
  module,
  label,
  description
});
var PERMISSION_CATALOGUE = [
  meta(PERMISSIONS.USERS_VIEW, "Administration", "View users", "List and view user accounts"),
  meta(PERMISSIONS.USERS_CREATE, "Administration", "Create users", "Create new user accounts"),
  meta(PERMISSIONS.USERS_UPDATE, "Administration", "Edit users", "Edit user details, roles and divisions"),
  meta(PERMISSIONS.USERS_DEACTIVATE, "Administration", "Deactivate users", "Deactivate or reactivate accounts"),
  meta(PERMISSIONS.USERS_RESET_PASSWORD, "Administration", "Reset passwords", "Force a password reset for a user"),
  meta(PERMISSIONS.ROLES_VIEW, "Administration", "View roles", "View roles and their permissions"),
  meta(PERMISSIONS.ROLES_MANAGE, "Administration", "Manage roles", "Create, edit and delete roles"),
  meta(PERMISSIONS.AUDIT_VIEW, "Administration", "View audit log", "Search the audit trail"),
  meta(PERMISSIONS.AUDIT_EXPORT, "Administration", "Export audit log", "Download audit trail exports"),
  meta(PERMISSIONS.SETTINGS_VIEW, "Administration", "View settings", "View company profile and system settings"),
  meta(PERMISSIONS.SETTINGS_MANAGE, "Administration", "Manage settings", "Edit company profile, branches, financial years"),
  meta(PERMISSIONS.NUMBER_SERIES_MANAGE, "Administration", "Manage number series", "Configure document numbering"),
  meta(PERMISSIONS.JOBS_VIEW, "Administration", "View background jobs", "See queue health and failed jobs"),
  meta(PERMISSIONS.JOBS_MANAGE, "Administration", "Manage background jobs", "Retry or remove failed jobs"),
  meta(PERMISSIONS.NOTIFICATION_TEMPLATES_MANAGE, "Administration", "Manage notification templates", "Edit email and in-app templates"),
  meta(PERMISSIONS.APPROVAL_RULES_MANAGE, "Administration", "Manage approval rules", "Configure approval limits and routing"),
  meta(PERMISSIONS.FILES_UPLOAD, "Documents", "Upload files", "Upload documents and images"),
  meta(PERMISSIONS.FILES_DOWNLOAD, "Documents", "Download files", "Download documents the user can access"),
  meta(PERMISSIONS.APPROVALS_VIEW, "Approvals", "View approvals", "See approval requests assigned to the user"),
  meta(PERMISSIONS.DATA_IMPORT, "Documents", "Import spreadsheets", "Import leads, customers, items, sites and opening stock from Excel/CSV"),
  meta(PERMISSIONS.DATA_IMPORT_SIGNOFF, "Documents", "Sign off data migration", "Check an import against the legacy system\u2019s control totals and sign off the rows that did not load"),
  meta(PERMISSIONS.LEADS_VIEW, "CRM", "View leads", "See own leads and leads of people who report to them"),
  meta(PERMISSIONS.LEADS_VIEW_ALL, "CRM", "View all leads", "See every lead in their divisions"),
  meta(PERMISSIONS.LEADS_CREATE, "CRM", "Create leads", "Add new leads"),
  meta(PERMISSIONS.LEADS_UPDATE, "CRM", "Edit leads", "Edit lead details and change status"),
  meta(PERMISSIONS.LEADS_ASSIGN, "CRM", "Assign leads", "Change the owner of a lead"),
  meta(PERMISSIONS.LEADS_CONVERT, "CRM", "Convert leads", "Convert a won lead into customer, project and site"),
  meta(PERMISSIONS.LEADS_EXPORT, "CRM", "Export leads", "Download lead lists"),
  meta(PERMISSIONS.ACTIVITIES_LOG, "CRM", "Log activities", "Record calls, meetings, notes and follow-ups"),
  meta(PERMISSIONS.FOLLOWUPS_TEAM, "CRM", "Team follow-ups", "See and reassign follow-ups of their team"),
  meta(PERMISSIONS.CUSTOMERS_VIEW, "CRM", "View customers", "See customers, contacts and Customer 360"),
  meta(PERMISSIONS.CUSTOMERS_CREATE, "CRM", "Create customers", "Add customers"),
  meta(PERMISSIONS.CUSTOMERS_UPDATE, "CRM", "Edit customers", "Edit customers, contacts and addresses"),
  meta(PERMISSIONS.CUSTOMERS_EXPORT, "CRM", "Export customers", "Download customer lists"),
  meta(PERMISSIONS.PARTNERS_VIEW, "CRM", "View channel partners", "See channel partners and referrals"),
  meta(PERMISSIONS.PARTNERS_MANAGE, "CRM", "Manage channel partners", "Add and edit channel partners"),
  meta(PERMISSIONS.PROJECTS_VIEW, "Projects", "View projects", "See projects and sites in their divisions"),
  meta(PERMISSIONS.PROJECTS_CREATE, "Projects", "Create projects", "Create projects and sites"),
  meta(PERMISSIONS.PROJECTS_UPDATE, "Projects", "Edit projects", "Edit projects and sites"),
  meta(PERMISSIONS.PROJECTS_EXPORT, "Projects", "Export projects", "Download project and site lists"),
  meta(PERMISSIONS.MASTERS_VIEW, "Masters", "View masters", "See items, price lists, suppliers and reference lists"),
  meta(PERMISSIONS.MASTERS_MANAGE, "Masters", "Manage reference lists", "Edit lead sources, campaigns, DISCOMs, districts, units and telecom clients"),
  meta(PERMISSIONS.ITEMS_MANAGE, "Masters", "Manage items", "Edit items and item categories"),
  meta(PERMISSIONS.PRICING_MANAGE, "Masters", "Manage price lists", "Edit price lists and rates"),
  meta(PERMISSIONS.TAX_MANAGE, "Masters", "Manage tax rates", "Edit GST rates and HSN/SAC codes"),
  meta(PERMISSIONS.SUPPLIERS_MANAGE, "Masters", "Manage suppliers", "Edit suppliers and vendors"),
  meta(PERMISSIONS.PROPOSALS_VIEW, "Proposals", "View proposals", "See own and team proposals"),
  meta(PERMISSIONS.PROPOSALS_VIEW_ALL, "Proposals", "View all proposals", "See every proposal in their divisions"),
  meta(PERMISSIONS.PROPOSALS_EDIT, "Proposals", "Create and edit proposals", "Build pages, upload PDFs and edit draft pricing"),
  meta(PERMISSIONS.PROPOSALS_APPROVE, "Proposals", "Approve proposals", "Approve proposal versions that need no rule-based approval"),
  meta(PERMISSIONS.PROPOSALS_SHARE, "Proposals", "Share proposals", "Mark approved proposals as shared and record customer responses"),
  meta(PERMISSIONS.PROPOSALS_PRICE_OVERRIDE, "Proposals", "Override prices", "Change a line rate away from the price list (with reason)"),
  meta(PERMISSIONS.PROPOSALS_VIEW_COST, "Proposals", "See cost and margin", "See internal cost and margin on proposals"),
  meta(PERMISSIONS.PROPOSAL_TEMPLATES_MANAGE, "Proposals", "Manage templates", "Edit proposal templates and reusable blocks"),
  meta(PERMISSIONS.QUOTATIONS_VIEW, "Billing", "View quotations", "See quotations in their divisions"),
  meta(PERMISSIONS.QUOTATIONS_EDIT, "Billing", "Create and edit quotations", "Prepare, submit, send and record outcomes of quotations"),
  meta(PERMISSIONS.QUOTATIONS_APPROVE, "Billing", "Approve quotations", "Approve quotations that need no rule-based approval"),
  meta(PERMISSIONS.INVOICES_VIEW, "Billing", "View invoices", "See proforma invoices, tax invoices, credit and debit notes"),
  meta(PERMISSIONS.INVOICES_EDIT, "Billing", "Prepare invoices", "Create and edit draft proforma and tax invoices, credit and debit notes"),
  meta(PERMISSIONS.INVOICES_APPROVE, "Billing", "Approve invoices", "Approve tax invoices and notes that need no rule-based approval"),
  meta(PERMISSIONS.INVOICES_POST, "Billing", "Post invoices", "Post approved tax invoices and notes (assigns the number and locks them)"),
  meta(PERMISSIONS.RECEIPTS_VIEW, "Billing", "View receipts", "See customer receipts and allocations"),
  meta(PERMISSIONS.RECEIPTS_CREATE, "Billing", "Record receipts", "Record customer payments and allocate them to invoices"),
  meta(PERMISSIONS.RECEIPTS_REVERSE, "Billing", "Reverse receipts", "Reverse a receipt with a reason (receipts are never deleted)"),
  meta(PERMISSIONS.LEDGER_VIEW, "Billing", "View customer ledgers", "See customer ledgers, outstanding and ageing"),
  meta(PERMISSIONS.STATEMENTS_SEND, "Billing", "Send statements", "Email documents and account statements to customers"),
  meta(PERMISSIONS.TAX_RULES_MANAGE, "Billing", "Manage tax rules", "Edit GST scenario rules (intra/inter-state, supply type)"),
  meta(PERMISSIONS.TAX_RULES_SIGN_OFF, "Billing", "Sign off tax rules", "Accountant sign-off that a tax rule is correct; required before invoices use it"),
  meta(PERMISSIONS.INVENTORY_VIEW, "Inventory", "View stock", "See stock on hand, movements, serials and reservations"),
  meta(PERMISSIONS.INVENTORY_MOVE, "Inventory", "Move stock", "Transfer stock and issue/return material to and from sites"),
  meta(PERMISSIONS.INVENTORY_ADJUST, "Inventory", "Adjust stock", "Record opening stock, damage write-offs and stock adjustments"),
  meta(PERMISSIONS.INVENTORY_APPROVE, "Inventory", "Approve adjustments", "Approve damage write-offs and stock adjustments"),
  meta(PERMISSIONS.INVENTORY_VIEW_COST, "Inventory", "See stock value", "See unit costs and stock valuation"),
  meta(PERMISSIONS.LOCATIONS_MANAGE, "Inventory", "Manage locations", "Add and edit warehouses and site stores"),
  meta(PERMISSIONS.PROJECT_BOM_MANAGE, "Inventory", "Manage project material plans", "Edit planned material (BOM) and reservations for projects"),
  meta(PERMISSIONS.COMPLIANCE_MANAGE, "Inventory", "Manage product compliance", "Edit ALMM/BIS rules and item certificates"),
  meta(PERMISSIONS.PROCUREMENT_VIEW, "Procurement", "View procurement", "See purchase requests, orders and goods receipts"),
  meta(PERMISSIONS.PR_CREATE, "Procurement", "Raise purchase requests", "Create and submit purchase requests"),
  meta(PERMISSIONS.PR_APPROVE, "Procurement", "Approve purchase requests", "Approve purchase requests that need no rule-based approval"),
  meta(PERMISSIONS.PO_MANAGE, "Procurement", "Manage purchase orders", "Create, send and close purchase orders"),
  meta(PERMISSIONS.PO_APPROVE, "Procurement", "Approve purchase orders", "Approve purchase orders that need no rule-based approval"),
  meta(PERMISSIONS.GRN_MANAGE, "Procurement", "Receive goods", "Record and post goods receipts into stock"),
  meta(PERMISSIONS.SURVEY_MANAGE, "Execution", "Record site surveys", "Create and edit site surveys with measurements, GPS and photos"),
  meta(PERMISSIONS.DESIGN_MANAGE, "Execution", "Record designs", "Enter or import Reslink design records"),
  meta(PERMISSIONS.DESIGN_APPROVE, "Execution", "Approve designs", "Approve a design version as the one to build"),
  meta(PERMISSIONS.EXECUTION_MANAGE, "Execution", "Manage execution", "Approve surveys, plan milestones, assign crews, complete commissioning and handover, record installed equipment"),
  meta(PERMISSIONS.CREWS_MANAGE, "Execution", "Manage crews", "Create installation crews and their members"),
  meta(PERMISSIONS.DPR_CREATE, "Execution", "Write daily reports", "Record daily progress reports with quantities, photos and defects"),
  meta(PERMISSIONS.DPR_SIGN_OFF, "Execution", "Sign off daily reports", "Sign off or return daily progress reports"),
  meta(PERMISSIONS.CHECKLIST_FILL, "Execution", "Fill checklists", "Tick commissioning and handover checklist items with evidence"),
  meta(PERMISSIONS.CHECKLIST_TEMPLATES_MANAGE, "Execution", "Manage checklist templates", "Configure commissioning and handover checklists"),
  meta(PERMISSIONS.DISCOM_MANAGE, "Execution", "Track DISCOM / net metering", "Record DISCOM applications and verified milestones"),
  meta(PERMISSIONS.SUBSIDY_VIEW, "Execution", "View subsidy tracker", "See PM Surya Ghar applications, milestones and subsidy amounts"),
  meta(PERMISSIONS.SUBSIDY_MANAGE, "Execution", "Manage subsidy tracker", "Record subsidy milestones, approvals and disbursements with evidence"),
  meta(PERMISSIONS.PROJECT_CLOSE, "Projects", "Close projects", "Close a project once its closure checks pass"),
  meta(PERMISSIONS.PROJECT_CLOSE_OVERRIDE, "Projects", "Close with exception", "Close a project although some closure checks fail, with a recorded reason"),
  meta(PERMISSIONS.WORK_ORDERS_MANAGE, "Telecom", "Manage work orders", "Create telecom work orders, rate cards, sites, billing milestones and conversion stages"),
  meta(PERMISSIONS.DISPATCH_MANAGE, "Telecom", "Dispatch material", "Dispatch material to telecom sites (needs stock movement rights) and resolve shortages"),
  meta(PERMISSIONS.DISPATCH_RECEIVE, "Telecom", "Confirm site receipt", "Record what arrived at site, shortages and delivery proof"),
  meta(PERMISSIONS.SITE_COMPLETION_MANAGE, "Telecom", "Record completion", "Record completion evidence and client sign-off for telecom sites"),
  meta(PERMISSIONS.TELECOM_BILLING_READY, "Telecom", "Mark billing ready", "Mark billing milestones ready under the contract"),
  meta(PERMISSIONS.TELECOM_BILLING, "Telecom", "Bill work orders", "Create invoices from executed quantities and milestones, record deductions, retention releases and submissions"),
  meta(PERMISSIONS.COLLECTIONS_MANAGE, "Billing", "Collection follow-up", "Record collection actions and promises to pay"),
  meta(PERMISSIONS.EXPENSES_VIEW, "Costs", "View all expenses", "See every expense and vendor bill (otherwise only your own)"),
  meta(PERMISSIONS.EXPENSES_CREATE, "Costs", "Record expenses", "Record expenses and vendor bills with attachments and submit them"),
  meta(PERMISSIONS.EXPENSES_APPROVE, "Costs", "Approve expenses", "Approve or return expenses recorded by others"),
  meta(PERMISSIONS.LABOUR_MANAGE, "Costs", "Record labour cost", "Maintain employee cost rates and record days or percentage on projects"),
  meta(PERMISSIONS.LABOUR_APPROVE, "Costs", "Approve labour cost", "Approve labour cost entries recorded by others"),
  meta(PERMISSIONS.REFERRALS_MANAGE, "Costs", "Propose referral bonuses", "Propose referral bonuses for projects and record payment"),
  meta(PERMISSIONS.REFERRALS_APPROVE, "Costs", "Approve referral bonuses", "Approve referral bonuses proposed by others"),
  meta(PERMISSIONS.OVERHEADS_MANAGE, "Costs", "Allocate overheads", "Create overhead pools and allocate them to projects"),
  meta(PERMISSIONS.CHANGE_ORDERS_MANAGE, "Projects", "Record change orders", "Record changes to the contract value of a project"),
  meta(PERMISSIONS.CHANGE_ORDERS_APPROVE, "Projects", "Approve change orders", "Approve change orders recorded by others"),
  meta(PERMISSIONS.ESTIMATES_MANAGE, "Costs", "Set estimates and recognise revenue", "Set the estimated cost of a project and record milestone revenue recognition"),
  meta(PERMISSIONS.PNL_VIEW, "Costs", "View project P&L", "See project and site profitability"),
  meta(PERMISSIONS.AI_USE, "AI", "Use AI assistants", "Proposal drafting and extraction, material plan drafts, follow-up and daily report assistants, forecast explanations"),
  meta(PERMISSIONS.AI_MANAGE, "Administration", "Manage AI settings", "Choose the AI provider, model and enabled features"),
  meta(PERMISSIONS.AI_COPILOT, "AI", "Ask the management copilot", "Ask questions about the business; answers use only data you may see and cite their records")
];
var ALL_PERMISSION_KEYS = PERMISSION_CATALOGUE.map((p) => p.key);

// src/roles.ts
var ROLE_CODES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  DIRECTOR: "DIRECTOR",
  SALES: "SALES",
  PROPOSAL_DESIGNER: "PROPOSAL_DESIGNER",
  SOLAR_PM: "SOLAR_PM",
  ENGINEER: "ENGINEER",
  INVENTORY: "INVENTORY",
  FINANCE: "FINANCE",
  SUBSIDY_COORDINATOR: "SUBSIDY_COORDINATOR",
  TELECOM_COORDINATOR: "TELECOM_COORDINATOR",
  AUDITOR: "AUDITOR"
};
var common = [PERMISSIONS.FILES_UPLOAD, PERMISSIONS.FILES_DOWNLOAD, PERMISSIONS.APPROVALS_VIEW];
var crmRead = [PERMISSIONS.LEADS_VIEW, PERMISSIONS.CUSTOMERS_VIEW, PERMISSIONS.PARTNERS_VIEW, PERMISSIONS.MASTERS_VIEW];
var SYSTEM_ROLES = [
  {
    code: ROLE_CODES.SUPER_ADMIN,
    name: "Super Admin",
    description: "Users, roles, master configuration, templates, numbering and system settings",
    permissions: ALL_PERMISSION_KEYS
  },
  {
    code: ROLE_CODES.DIRECTOR,
    name: "Director / Management",
    description: "Cross-division dashboards, approvals, P&L, high-value discounts, exceptions and reports",
    permissions: [
      ...common,
      ...crmRead,
      PERMISSIONS.USERS_VIEW,
      PERMISSIONS.ROLES_VIEW,
      PERMISSIONS.AUDIT_VIEW,
      PERMISSIONS.AUDIT_EXPORT,
      PERMISSIONS.SETTINGS_VIEW,
      PERMISSIONS.LEADS_VIEW_ALL,
      PERMISSIONS.LEADS_ASSIGN,
      PERMISSIONS.LEADS_EXPORT,
      PERMISSIONS.FOLLOWUPS_TEAM,
      PERMISSIONS.CUSTOMERS_EXPORT,
      PERMISSIONS.PROJECTS_VIEW,
      PERMISSIONS.PROJECTS_EXPORT,
      PERMISSIONS.PROPOSALS_VIEW,
      PERMISSIONS.PROPOSALS_VIEW_ALL,
      PERMISSIONS.PROPOSALS_APPROVE,
      PERMISSIONS.PROPOSALS_SHARE,
      PERMISSIONS.PROPOSALS_PRICE_OVERRIDE,
      PERMISSIONS.PROPOSALS_VIEW_COST,
      PERMISSIONS.QUOTATIONS_VIEW,
      PERMISSIONS.QUOTATIONS_APPROVE,
      PERMISSIONS.INVOICES_VIEW,
      PERMISSIONS.INVOICES_APPROVE,
      PERMISSIONS.RECEIPTS_VIEW,
      PERMISSIONS.LEDGER_VIEW,
      PERMISSIONS.INVENTORY_VIEW,
      PERMISSIONS.INVENTORY_APPROVE,
      PERMISSIONS.INVENTORY_VIEW_COST,
      PERMISSIONS.PROCUREMENT_VIEW,
      PERMISSIONS.PR_APPROVE,
      PERMISSIONS.PO_APPROVE,
      PERMISSIONS.DESIGN_APPROVE,
      PERMISSIONS.DPR_SIGN_OFF,
      PERMISSIONS.SUBSIDY_VIEW,
      PERMISSIONS.PROJECT_CLOSE,
      PERMISSIONS.PROJECT_CLOSE_OVERRIDE,
      PERMISSIONS.COLLECTIONS_MANAGE,
      PERMISSIONS.EXPENSES_VIEW,
      PERMISSIONS.EXPENSES_APPROVE,
      PERMISSIONS.LABOUR_APPROVE,
      PERMISSIONS.REFERRALS_APPROVE,
      PERMISSIONS.CHANGE_ORDERS_APPROVE,
      PERMISSIONS.PNL_VIEW,
      PERMISSIONS.AI_USE,
      PERMISSIONS.AI_COPILOT,
      PERMISSIONS.DATA_IMPORT_SIGNOFF
    ]
  },
  {
    code: ROLE_CODES.SALES,
    name: "Sales / CRM",
    description: "Leads, follow-ups, customer data and proposal drafts",
    permissions: [
      ...common,
      ...crmRead,
      PERMISSIONS.LEADS_CREATE,
      PERMISSIONS.LEADS_UPDATE,
      PERMISSIONS.LEADS_CONVERT,
      PERMISSIONS.ACTIVITIES_LOG,
      PERMISSIONS.CUSTOMERS_CREATE,
      PERMISSIONS.CUSTOMERS_UPDATE,
      PERMISSIONS.PROJECTS_VIEW,
      PERMISSIONS.PROJECTS_CREATE,
      PERMISSIONS.PROPOSALS_VIEW,
      PERMISSIONS.PROPOSALS_EDIT,
      PERMISSIONS.PROPOSALS_SHARE,
      PERMISSIONS.QUOTATIONS_VIEW,
      PERMISSIONS.QUOTATIONS_EDIT,
      PERMISSIONS.INVOICES_VIEW,
      PERMISSIONS.RECEIPTS_VIEW,
      PERMISSIONS.LEDGER_VIEW,
      PERMISSIONS.AI_USE,
      PERMISSIONS.AI_COPILOT
    ]
  },
  {
    code: ROLE_CODES.PROPOSAL_DESIGNER,
    name: "Proposal Designer",
    description: "Draft pages, upload PDFs, use templates and blocks",
    permissions: [
      ...common,
      PERMISSIONS.LEADS_VIEW,
      PERMISSIONS.CUSTOMERS_VIEW,
      PERMISSIONS.MASTERS_VIEW,
      PERMISSIONS.PROJECTS_VIEW,
      PERMISSIONS.PROPOSALS_VIEW,
      PERMISSIONS.PROPOSALS_VIEW_ALL,
      PERMISSIONS.PROPOSALS_EDIT,
      PERMISSIONS.PROPOSAL_TEMPLATES_MANAGE,
      PERMISSIONS.AI_USE
    ]
  },
  {
    code: ROLE_CODES.SOLAR_PM,
    name: "Solar Project Manager",
    description: "Site onboarding, survey, planning, installation, DPR, commissioning and handover",
    permissions: [
      ...common,
      ...crmRead,
      PERMISSIONS.ACTIVITIES_LOG,
      PERMISSIONS.PROJECTS_VIEW,
      PERMISSIONS.PROJECTS_CREATE,
      PERMISSIONS.PROJECTS_UPDATE,
      PERMISSIONS.PROJECTS_EXPORT,
      PERMISSIONS.PROPOSALS_VIEW,
      PERMISSIONS.INVENTORY_VIEW,
      PERMISSIONS.PROCUREMENT_VIEW,
      PERMISSIONS.PR_CREATE,
      PERMISSIONS.PROJECT_BOM_MANAGE,
      PERMISSIONS.SURVEY_MANAGE,
      PERMISSIONS.DESIGN_MANAGE,
      PERMISSIONS.DESIGN_APPROVE,
      PERMISSIONS.EXECUTION_MANAGE,
      PERMISSIONS.CREWS_MANAGE,
      PERMISSIONS.DPR_CREATE,
      PERMISSIONS.DPR_SIGN_OFF,
      PERMISSIONS.CHECKLIST_FILL,
      PERMISSIONS.CHECKLIST_TEMPLATES_MANAGE,
      PERMISSIONS.DISCOM_MANAGE,
      PERMISSIONS.SUBSIDY_VIEW,
      PERMISSIONS.PROJECT_CLOSE,
      PERMISSIONS.EXPENSES_CREATE,
      PERMISSIONS.LABOUR_MANAGE,
      PERMISSIONS.CHANGE_ORDERS_MANAGE,
      PERMISSIONS.REFERRALS_MANAGE,
      PERMISSIONS.ESTIMATES_MANAGE,
      PERMISSIONS.PNL_VIEW,
      PERMISSIONS.AI_USE,
      PERMISSIONS.AI_COPILOT
    ]
  },
  {
    code: ROLE_CODES.ENGINEER,
    name: "Engineer / Installer",
    description: "Assigned site checklist, measurements, photos, actual work and material usage",
    permissions: [PERMISSIONS.FILES_UPLOAD, PERMISSIONS.FILES_DOWNLOAD, PERMISSIONS.PROJECTS_VIEW, PERMISSIONS.SURVEY_MANAGE, PERMISSIONS.DPR_CREATE, PERMISSIONS.CHECKLIST_FILL, PERMISSIONS.DISPATCH_RECEIVE, PERMISSIONS.EXPENSES_CREATE]
  },
  {
    code: ROLE_CODES.INVENTORY,
    name: "Inventory / Procurement",
    description: "Purchase requests, stock receipts, issues, transfers, returns and suppliers",
    permissions: [
      ...common,
      PERMISSIONS.MASTERS_VIEW,
      PERMISSIONS.ITEMS_MANAGE,
      PERMISSIONS.SUPPLIERS_MANAGE,
      PERMISSIONS.DATA_IMPORT,
      PERMISSIONS.PROJECTS_VIEW,
      PERMISSIONS.INVENTORY_VIEW,
      PERMISSIONS.INVENTORY_MOVE,
      PERMISSIONS.INVENTORY_ADJUST,
      PERMISSIONS.INVENTORY_VIEW_COST,
      PERMISSIONS.LOCATIONS_MANAGE,
      PERMISSIONS.PROJECT_BOM_MANAGE,
      PERMISSIONS.COMPLIANCE_MANAGE,
      PERMISSIONS.PROCUREMENT_VIEW,
      PERMISSIONS.PR_CREATE,
      PERMISSIONS.PO_MANAGE,
      PERMISSIONS.GRN_MANAGE,
      PERMISSIONS.DISPATCH_MANAGE,
      PERMISSIONS.DISPATCH_RECEIVE,
      PERMISSIONS.AI_USE
    ]
  },
  {
    code: ROLE_CODES.FINANCE,
    name: "Finance / Accounts",
    description: "Proforma and tax invoices, receipts, expenses, allocations, ledgers, tax configuration and P&L",
    permissions: [
      ...common,
      ...crmRead,
      PERMISSIONS.SETTINGS_VIEW,
      PERMISSIONS.NUMBER_SERIES_MANAGE,
      PERMISSIONS.PRICING_MANAGE,
      PERMISSIONS.TAX_MANAGE,
      PERMISSIONS.CUSTOMERS_UPDATE,
      PERMISSIONS.CUSTOMERS_EXPORT,
      PERMISSIONS.PROJECTS_VIEW,
      PERMISSIONS.PROJECTS_EXPORT,
      PERMISSIONS.PROPOSALS_VIEW,
      PERMISSIONS.PROPOSALS_VIEW_ALL,
      PERMISSIONS.PROPOSALS_VIEW_COST,
      PERMISSIONS.QUOTATIONS_VIEW,
      PERMISSIONS.QUOTATIONS_EDIT,
      PERMISSIONS.INVOICES_VIEW,
      PERMISSIONS.INVOICES_EDIT,
      PERMISSIONS.INVOICES_APPROVE,
      PERMISSIONS.INVOICES_POST,
      PERMISSIONS.RECEIPTS_VIEW,
      PERMISSIONS.RECEIPTS_CREATE,
      PERMISSIONS.RECEIPTS_REVERSE,
      PERMISSIONS.LEDGER_VIEW,
      PERMISSIONS.STATEMENTS_SEND,
      PERMISSIONS.TAX_RULES_MANAGE,
      PERMISSIONS.TAX_RULES_SIGN_OFF,
      PERMISSIONS.INVENTORY_VIEW,
      PERMISSIONS.INVENTORY_VIEW_COST,
      PERMISSIONS.PROCUREMENT_VIEW,
      PERMISSIONS.SUBSIDY_VIEW,
      PERMISSIONS.TELECOM_BILLING,
      PERMISSIONS.COLLECTIONS_MANAGE,
      PERMISSIONS.EXPENSES_VIEW,
      PERMISSIONS.EXPENSES_CREATE,
      PERMISSIONS.EXPENSES_APPROVE,
      PERMISSIONS.LABOUR_MANAGE,
      PERMISSIONS.LABOUR_APPROVE,
      PERMISSIONS.REFERRALS_MANAGE,
      PERMISSIONS.REFERRALS_APPROVE,
      PERMISSIONS.OVERHEADS_MANAGE,
      PERMISSIONS.CHANGE_ORDERS_APPROVE,
      PERMISSIONS.ESTIMATES_MANAGE,
      PERMISSIONS.PNL_VIEW,
      PERMISSIONS.AI_USE,
      PERMISSIONS.AI_COPILOT,
      PERMISSIONS.DATA_IMPORT_SIGNOFF
    ]
  },
  {
    code: ROLE_CODES.SUBSIDY_COORDINATOR,
    name: "Subsidy Coordinator",
    description: "Portal milestones, pending documents, evidence and disbursement records",
    permissions: [...common, PERMISSIONS.CUSTOMERS_VIEW, PERMISSIONS.ACTIVITIES_LOG, PERMISSIONS.PROJECTS_VIEW, PERMISSIONS.DISCOM_MANAGE, PERMISSIONS.SUBSIDY_VIEW, PERMISSIONS.SUBSIDY_MANAGE]
  },
  {
    code: ROLE_CODES.TELECOM_COORDINATOR,
    name: "Telecom Coordinator",
    description: "Telecom work orders, sites, logistics, DPR, completion and billing readiness",
    permissions: [
      ...common,
      ...crmRead,
      PERMISSIONS.ACTIVITIES_LOG,
      PERMISSIONS.PROJECTS_VIEW,
      PERMISSIONS.PROJECTS_CREATE,
      PERMISSIONS.PROJECTS_UPDATE,
      PERMISSIONS.INVENTORY_VIEW,
      PERMISSIONS.PROCUREMENT_VIEW,
      PERMISSIONS.PR_CREATE,
      PERMISSIONS.EXECUTION_MANAGE,
      PERMISSIONS.DPR_CREATE,
      PERMISSIONS.DPR_SIGN_OFF,
      PERMISSIONS.PROJECT_CLOSE,
      PERMISSIONS.WORK_ORDERS_MANAGE,
      PERMISSIONS.DISPATCH_RECEIVE,
      PERMISSIONS.SITE_COMPLETION_MANAGE,
      PERMISSIONS.TELECOM_BILLING_READY,
      PERMISSIONS.CHECKLIST_FILL,
      PERMISSIONS.CREWS_MANAGE,
      PERMISSIONS.PROJECT_BOM_MANAGE,
      PERMISSIONS.QUOTATIONS_VIEW,
      PERMISSIONS.INVOICES_VIEW,
      PERMISSIONS.RECEIPTS_VIEW,
      PERMISSIONS.LEDGER_VIEW,
      PERMISSIONS.EXPENSES_CREATE,
      PERMISSIONS.LABOUR_MANAGE,
      PERMISSIONS.CHANGE_ORDERS_MANAGE,
      PERMISSIONS.ESTIMATES_MANAGE,
      PERMISSIONS.PNL_VIEW,
      PERMISSIONS.AI_USE,
      PERMISSIONS.AI_COPILOT
    ]
  },
  {
    code: ROLE_CODES.AUDITOR,
    name: "Auditor / Read-only",
    description: "Authorised read-only records, approvals and audit reports",
    permissions: [
      PERMISSIONS.USERS_VIEW,
      PERMISSIONS.ROLES_VIEW,
      PERMISSIONS.AUDIT_VIEW,
      PERMISSIONS.AUDIT_EXPORT,
      PERMISSIONS.SETTINGS_VIEW,
      PERMISSIONS.FILES_DOWNLOAD,
      ...crmRead,
      PERMISSIONS.LEADS_VIEW_ALL,
      PERMISSIONS.PROJECTS_VIEW,
      PERMISSIONS.PROPOSALS_VIEW,
      PERMISSIONS.PROPOSALS_VIEW_ALL,
      PERMISSIONS.QUOTATIONS_VIEW,
      PERMISSIONS.INVOICES_VIEW,
      PERMISSIONS.RECEIPTS_VIEW,
      PERMISSIONS.LEDGER_VIEW,
      PERMISSIONS.INVENTORY_VIEW,
      PERMISSIONS.INVENTORY_VIEW_COST,
      PERMISSIONS.PROCUREMENT_VIEW,
      PERMISSIONS.SUBSIDY_VIEW,
      PERMISSIONS.EXPENSES_VIEW,
      PERMISSIONS.PNL_VIEW
    ]
  }
];

// src/enums.ts
var DIVISIONS = {
  SOLAR: "SOLAR",
  TELECOM: "TELECOM"
};
var AUDIT_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "DEACTIVATE",
  "REACTIVATE",
  "LOGIN",
  "LOGIN_FAILED",
  "LOGOUT",
  "PASSWORD_CHANGE",
  "PASSWORD_RESET",
  "MFA_ENABLE",
  "MFA_DISABLE",
  "SESSION_REVOKE",
  "APPROVE",
  "REJECT",
  "SUBMIT",
  "CANCEL",
  "EXPORT",
  "SHARE",
  "DOWNLOAD",
  "UPLOAD",
  "NUMBER_ALLOCATE",
  "JOB_RETRY",
  "JOB_REMOVE"
];
var APPROVAL_STATUS = ["PENDING", "APPROVED", "REJECTED", "CANCELLED"];
var DOCUMENT_TYPES = [
  { code: "LEAD", label: "Lead" },
  { code: "CUSTOMER", label: "Customer" },
  { code: "PROJECT", label: "Project" },
  { code: "PROPOSAL", label: "Proposal" },
  { code: "QUOTATION", label: "Quotation" },
  { code: "PROFORMA", label: "Proforma invoice" },
  { code: "TAX_INVOICE", label: "Tax invoice" },
  { code: "CREDIT_NOTE", label: "Credit note" },
  { code: "DEBIT_NOTE", label: "Debit note" },
  { code: "RECEIPT", label: "Receipt" },
  { code: "PURCHASE_REQUEST", label: "Purchase request" },
  { code: "PURCHASE_ORDER", label: "Purchase order" },
  { code: "GOODS_RECEIPT", label: "Goods receipt" },
  { code: "WORK_ORDER", label: "Telecom work order" },
  { code: "STOCK_TRANSFER", label: "Stock transfer" },
  { code: "MATERIAL_ISSUE", label: "Material issue to site" },
  { code: "MATERIAL_RETURN", label: "Material return from site" },
  { code: "STOCK_ADJUSTMENT", label: "Stock adjustment / write-off" },
  { code: "EXPENSE", label: "Expense / vendor bill" },
  { code: "CHANGE_ORDER", label: "Change order" },
  { code: "REFERRAL_BONUS", label: "Referral bonus" }
];
var INDIAN_STATES = [
  { code: "JK", gstCode: "01", name: "Jammu and Kashmir" },
  { code: "HP", gstCode: "02", name: "Himachal Pradesh" },
  { code: "PB", gstCode: "03", name: "Punjab" },
  { code: "CH", gstCode: "04", name: "Chandigarh" },
  { code: "UK", gstCode: "05", name: "Uttarakhand" },
  { code: "HR", gstCode: "06", name: "Haryana" },
  { code: "DL", gstCode: "07", name: "Delhi" },
  { code: "RJ", gstCode: "08", name: "Rajasthan" },
  { code: "UP", gstCode: "09", name: "Uttar Pradesh" },
  { code: "BR", gstCode: "10", name: "Bihar" },
  { code: "SK", gstCode: "11", name: "Sikkim" },
  { code: "AR", gstCode: "12", name: "Arunachal Pradesh" },
  { code: "NL", gstCode: "13", name: "Nagaland" },
  { code: "MN", gstCode: "14", name: "Manipur" },
  { code: "MZ", gstCode: "15", name: "Mizoram" },
  { code: "TR", gstCode: "16", name: "Tripura" },
  { code: "ML", gstCode: "17", name: "Meghalaya" },
  { code: "AS", gstCode: "18", name: "Assam" },
  { code: "WB", gstCode: "19", name: "West Bengal" },
  { code: "JH", gstCode: "20", name: "Jharkhand" },
  { code: "OD", gstCode: "21", name: "Odisha" },
  { code: "CG", gstCode: "22", name: "Chhattisgarh" },
  { code: "MP", gstCode: "23", name: "Madhya Pradesh" },
  { code: "GJ", gstCode: "24", name: "Gujarat" },
  { code: "DN", gstCode: "26", name: "Dadra and Nagar Haveli and Daman and Diu" },
  { code: "MH", gstCode: "27", name: "Maharashtra" },
  { code: "KA", gstCode: "29", name: "Karnataka" },
  { code: "GA", gstCode: "30", name: "Goa" },
  { code: "LD", gstCode: "31", name: "Lakshadweep" },
  { code: "KL", gstCode: "32", name: "Kerala" },
  { code: "TN", gstCode: "33", name: "Tamil Nadu" },
  { code: "PY", gstCode: "34", name: "Puducherry" },
  { code: "AN", gstCode: "35", name: "Andaman and Nicobar Islands" },
  { code: "TS", gstCode: "36", name: "Telangana" },
  { code: "AP", gstCode: "37", name: "Andhra Pradesh" },
  { code: "LA", gstCode: "38", name: "Ladakh" }
];

// src/gst.ts
var GSTIN_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
var GSTIN_PATTERN = /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
function gstinCheckChar(first14) {
  let sum = 0;
  for (let i = 0; i < 14; i++) {
    const value = GSTIN_CHARS.indexOf(first14[i]);
    const factor = i % 2 === 0 ? 1 : 2;
    const product = value * factor;
    sum += Math.floor(product / 36) + product % 36;
  }
  const check = (36 - sum % 36) % 36;
  return GSTIN_CHARS[check];
}
function isValidGstin(gstin) {
  const value = gstin.trim().toUpperCase();
  if (!GSTIN_PATTERN.test(value)) return false;
  const stateCode2 = value.slice(0, 2);
  if (!INDIAN_STATES.some((s) => s.gstCode === stateCode2) && stateCode2 !== "97" && stateCode2 !== "99") return false;
  return gstinCheckChar(value.slice(0, 14)) === value[14];
}
function stateFromGstin(gstin) {
  return INDIAN_STATES.find((s) => s.gstCode === gstin.slice(0, 2)) ?? null;
}

// src/money.ts
import Decimal from "decimal.js";
function formatIndianNumber(value, fractionDigits = 2) {
  const d = new Decimal(value);
  const negative = d.isNegative();
  const fixed = d.abs().toFixed(fractionDigits);
  const [intPart, frac] = fixed.split(".");
  let grouped;
  if (intPart.length <= 3) {
    grouped = intPart;
  } else {
    const last3 = intPart.slice(-3);
    const rest = intPart.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    grouped = `${rest},${last3}`;
  }
  return `${negative ? "-" : ""}${grouped}${frac ? `.${frac}` : ""}`;
}
function formatINR(value, fractionDigits = 2) {
  const s = formatIndianNumber(value, fractionDigits);
  return s.startsWith("-") ? `-\u20B9${s.slice(1)}` : `\u20B9${s}`;
}
var ONES = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen"
];
var TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
function twoDigits(n) {
  if (n < 20) return ONES[n];
  return `${TENS[Math.floor(n / 10)]}${n % 10 ? ` ${ONES[n % 10]}` : ""}`;
}
function threeDigits(n) {
  const h = Math.floor(n / 100);
  const r = n % 100;
  return [h ? `${ONES[h]} Hundred` : "", r ? twoDigits(r) : ""].filter(Boolean).join(" ");
}
function integerToIndianWords(n) {
  if (n === 0) return "Zero";
  const parts = [];
  const crore = Math.floor(n / 1e7);
  n %= 1e7;
  const lakh = Math.floor(n / 1e5);
  n %= 1e5;
  const thousand = Math.floor(n / 1e3);
  n %= 1e3;
  if (crore) parts.push(`${integerToIndianWords(crore)} Crore`);
  if (lakh) parts.push(`${twoDigits(lakh)} Lakh`);
  if (thousand) parts.push(`${twoDigits(thousand)} Thousand`);
  if (n) parts.push(threeDigits(n));
  return parts.join(" ");
}
function amountInWords(value) {
  const d = new Decimal(value).toDecimalPlaces(2);
  if (d.isNegative()) return `Minus ${amountInWords(d.abs())}`;
  const rupees = d.floor().toNumber();
  const paise = d.minus(d.floor()).times(100).round().toNumber();
  let words = `Rupees ${integerToIndianWords(rupees)}`;
  if (paise > 0) words += ` and ${twoDigits(paise)} Paise`;
  return `${words} Only`;
}
function roundMoney(value) {
  return new Decimal(value).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}

// src/fy.ts
function financialYearCodeFor(date) {
  const year = date.getMonth() >= 3 ? date.getFullYear() : date.getFullYear() - 1;
  return `${year}-${String((year + 1) % 100).padStart(2, "0")}`;
}
function financialYearBounds(code2) {
  const startYear = Number(code2.slice(0, 4));
  return {
    start: new Date(Date.UTC(startYear, 3, 1)),
    end: new Date(Date.UTC(startYear + 1, 2, 31))
  };
}
function formatDocumentNumber(prefix, suffix, padding, sequence, fyCode) {
  const replace = (s) => s.replaceAll("{FY}", fyCode).replaceAll("{FYS}", `${fyCode.slice(2, 4)}-${fyCode.slice(5, 7)}`).replaceAll("{YYYY}", fyCode.slice(0, 4));
  return `${replace(prefix)}${String(sequence).padStart(padding, "0")}${replace(suffix)}`;
}

// src/schemas/common.ts
import { z } from "zod";
var uuid = z.string().uuid();
var listQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(25),
  sort: z.string().regex(/^[a-zA-Z0-9_.]+:(asc|desc)$/, "Use field:asc or field:desc").optional(),
  search: z.string().trim().max(200).optional()
});
var phoneSchema = z.string().trim().regex(/^(\+91[\s-]?|0)?[6-9]\d{4}[\s-]?\d{5}$/, "Enter a valid 10-digit Indian mobile number");
var optionalPhone = z.union([phoneSchema, z.literal("")]).optional().nullable();
var pincodeSchema = z.string().trim().regex(/^[1-9]\d{5}$/, "Enter a valid 6-digit PIN code");
var optionalString = (max = 255) => z.string().trim().max(max).optional().nullable();

// src/schemas/auth.ts
import { z as z2 } from "zod";
var PASSWORD_MIN_LENGTH = 10;
var passwordSchema = z2.string().min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters`).max(128, "Password must be at most 128 characters").regex(/[a-z]/, "Password must contain a lowercase letter").regex(/[A-Z]/, "Password must contain an uppercase letter").regex(/\d/, "Password must contain a number").regex(/[^A-Za-z0-9]/, "Password must contain a symbol");
var loginSchema = z2.object({
  email: z2.string().trim().toLowerCase().email("Enter a valid email address"),
  password: z2.string().min(1, "Password is required"),
  mfaCode: z2.string().regex(/^\d{6}$/, "Enter the 6-digit code").optional()
});
var forgotPasswordSchema = z2.object({
  email: z2.string().trim().toLowerCase().email("Enter a valid email address")
});
var resetPasswordSchema = z2.object({
  token: z2.string().min(20),
  password: passwordSchema,
  confirmPassword: z2.string()
}).refine((v) => v.password === v.confirmPassword, {
  path: ["confirmPassword"],
  message: "Passwords do not match"
});
var changePasswordSchema = z2.object({
  currentPassword: z2.string().min(1, "Current password is required"),
  newPassword: passwordSchema,
  confirmPassword: z2.string()
}).refine((v) => v.newPassword === v.confirmPassword, {
  path: ["confirmPassword"],
  message: "Passwords do not match"
}).refine((v) => v.newPassword !== v.currentPassword, {
  path: ["newPassword"],
  message: "New password must be different from the current password"
});
var mfaCodeSchema = z2.object({
  code: z2.string().regex(/^\d{6}$/, "Enter the 6-digit code")
});
var mfaDisableSchema = z2.object({
  password: z2.string().min(1, "Password is required"),
  code: z2.string().regex(/^\d{6}$/, "Enter the 6-digit code")
});
var updateProfileSchema = z2.object({
  fullName: z2.string().trim().min(2, "Name is required").max(120),
  phone: z2.string().trim().regex(/^(\+91[\s-]?|0)?[6-9]\d{4}[\s-]?\d{5}$/, "Enter a valid 10-digit Indian mobile number").or(z2.literal("")).optional().nullable()
});

// src/schemas/admin.ts
import { z as z3 } from "zod";
var divisionEnum = z3.enum([DIVISIONS.SOLAR, DIVISIONS.TELECOM]);
var createUserSchema = z3.object({
  email: z3.string().trim().toLowerCase().email("Enter a valid email address"),
  fullName: z3.string().trim().min(2, "Name is required").max(120),
  phone: z3.string().trim().regex(/^(\+91[\s-]?|0)?[6-9]\d{4}[\s-]?\d{5}$/, "Enter a valid 10-digit Indian mobile number").or(z3.literal("")).optional().nullable(),
  employeeCode: optionalString(40),
  designation: optionalString(80),
  roleIds: z3.array(z3.string().uuid()).min(1, "Assign at least one role"),
  divisions: z3.array(divisionEnum).min(1, "Assign at least one division"),
  /** Manager for team views and follow-up escalation. */
  managerId: z3.string().uuid().optional().nullable(),
  /** Initial password. The user must change it on first login. */
  password: passwordSchema
});
var updateUserSchema = createUserSchema.omit({ password: true, email: true }).partial().extend({
  email: z3.string().trim().toLowerCase().email("Enter a valid email address").optional()
});
var adminResetPasswordSchema = z3.object({ password: passwordSchema });
var userListQuerySchema = listQuerySchema.extend({
  status: z3.enum(["active", "inactive", "all"]).default("active"),
  roleId: z3.string().uuid().optional(),
  division: divisionEnum.optional()
});
var roleSchema = z3.object({
  code: z3.string().trim().toUpperCase().regex(/^[A-Z][A-Z0-9_]{1,39}$/, "Use capital letters, numbers and underscores"),
  name: z3.string().trim().min(2).max(80),
  description: optionalString(500),
  permissions: z3.array(z3.string()).default([])
});
var updateRoleSchema = roleSchema.omit({ code: true }).partial();
var companyProfileSchema = z3.object({
  legalName: z3.string().trim().min(2).max(200),
  tradeName: optionalString(200),
  gstin: z3.string().trim().toUpperCase().refine((v) => v === "" || isValidGstin(v), "Enter a valid 15-character GSTIN").optional().nullable(),
  pan: z3.string().trim().toUpperCase().regex(/^[A-Z]{5}\d{4}[A-Z]$/, "Enter a valid PAN").or(z3.literal("")).optional().nullable(),
  cin: optionalString(30),
  email: z3.string().trim().email().or(z3.literal("")).optional().nullable(),
  phone: optionalString(30),
  website: optionalString(200),
  addressLine1: z3.string().trim().min(2).max(200),
  addressLine2: optionalString(200),
  city: z3.string().trim().min(2).max(80),
  stateCode: z3.string().trim().length(2),
  pincode: pincodeSchema,
  bankName: optionalString(120),
  bankAccountName: optionalString(120),
  bankAccountNumber: optionalString(30),
  bankIfsc: z3.string().trim().toUpperCase().regex(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC").or(z3.literal("")).optional().nullable(),
  bankBranch: optionalString(120),
  upiId: optionalString(80),
  logoFileId: z3.string().uuid().optional().nullable(),
  signatureFileId: z3.string().uuid().optional().nullable()
});
var branchSchema = z3.object({
  code: z3.string().trim().toUpperCase().regex(/^[A-Z0-9-]{2,20}$/, "Use 2\u201320 capital letters, digits or hyphens"),
  name: z3.string().trim().min(2).max(120),
  gstin: z3.string().trim().toUpperCase().refine((v) => v === "" || isValidGstin(v), "Enter a valid 15-character GSTIN").optional().nullable(),
  addressLine1: z3.string().trim().min(2).max(200),
  addressLine2: optionalString(200),
  city: z3.string().trim().min(2).max(80),
  stateCode: z3.string().trim().length(2),
  pincode: pincodeSchema,
  phone: optionalString(30),
  isActive: z3.boolean().default(true)
});
var financialYearSchema = z3.object({
  code: z3.string().trim().regex(/^\d{4}-\d{2}$/, "Use the format 2026-27"),
  startDate: z3.coerce.date(),
  endDate: z3.coerce.date(),
  isCurrent: z3.boolean().default(false)
}).refine((v) => v.endDate > v.startDate, { path: ["endDate"], message: "End date must be after start date" });
var numberSeriesSchema = z3.object({
  documentType: z3.string().trim().min(2).max(40),
  financialYearId: z3.string().uuid(),
  division: divisionEnum.optional().nullable(),
  prefix: z3.string().trim().max(30).regex(/^[A-Za-z0-9/\-{}]*$/, "Prefix may contain letters, digits, / - and {FY} tokens"),
  suffix: z3.string().trim().max(20).regex(/^[A-Za-z0-9/\-{}]*$/).default(""),
  padding: z3.coerce.number().int().min(1).max(10).default(4),
  nextNumber: z3.coerce.number().int().min(1).default(1),
  isActive: z3.boolean().default(true)
});
var updateNumberSeriesSchema = numberSeriesSchema.pick({ prefix: true, suffix: true, padding: true, nextNumber: true, isActive: true }).partial();
var approvalRuleSchema = z3.object({
  name: z3.string().trim().min(2).max(120),
  documentType: z3.string().trim().min(2).max(40),
  division: divisionEnum.optional().nullable(),
  minAmount: z3.coerce.number().min(0).optional().nullable(),
  maxAmount: z3.coerce.number().min(0).optional().nullable(),
  minDiscountPercent: z3.coerce.number().min(0).max(100).optional().nullable(),
  maxMarginPercent: z3.coerce.number().min(-100).max(100).optional().nullable(),
  /** Ordered approval steps: each step needs one approver holding the given role. */
  steps: z3.array(z3.object({ roleId: z3.string().uuid() })).min(1, "Add at least one approval step").max(5),
  priority: z3.coerce.number().int().min(0).default(100),
  isActive: z3.boolean().default(true)
});
var approvalDecisionSchema = z3.object({
  comment: z3.string().trim().max(1e3).optional().nullable()
});
var approvalRejectSchema = z3.object({
  comment: z3.string().trim().min(3, "Give a reason for rejecting").max(1e3)
});
var notificationTemplateSchema = z3.object({
  subject: z3.string().trim().min(2).max(200),
  bodyHtml: z3.string().min(2).max(2e4),
  bodyText: z3.string().min(2).max(1e4),
  isActive: z3.boolean().default(true)
});
var auditQuerySchema = listQuerySchema.extend({
  entityType: z3.string().max(60).optional(),
  entityId: z3.string().max(60).optional(),
  actorId: z3.string().uuid().optional(),
  action: z3.string().max(40).optional(),
  from: z3.coerce.date().optional(),
  to: z3.coerce.date().optional()
});
var securitySettingsSchema = z3.object({
  maxFailedLogins: z3.coerce.number().int().min(3).max(20).default(5),
  lockoutMinutes: z3.coerce.number().int().min(1).max(1440).default(15),
  passwordResetTtlMinutes: z3.coerce.number().int().min(10).max(1440).default(60),
  /** Role codes whose members are reminded to enrol in two-factor authentication. */
  mfaRequiredRoleCodes: z3.array(z3.string()).default([])
});
var UPLOAD_MIME_OPTIONS = [
  { value: "application/pdf", label: "PDF" },
  { value: "image/jpeg", label: "JPEG image" },
  { value: "image/png", label: "PNG image" },
  { value: "image/webp", label: "WebP image" },
  { value: "text/csv", label: "CSV" },
  { value: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", label: "Excel (.xlsx)" },
  { value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", label: "Word (.docx)" }
];
var uploadSettingsSchema = z3.object({
  maxUploadMb: z3.coerce.number().int().min(1).max(2048).default(50),
  allowedMimeTypes: z3.array(z3.enum(UPLOAD_MIME_OPTIONS.map((o) => o.value))).min(1, "Allow at least one file type").default(UPLOAD_MIME_OPTIONS.map((o) => o.value))
});
var crmSettingsSchema = z3.object({
  /** Remind the assignee this many minutes before a follow-up is due. */
  reminderLeadMinutes: z3.coerce.number().int().min(0).max(1440).default(15),
  /** Escalate to the assignee's manager when a follow-up is overdue by this many hours. */
  escalateAfterHours: z3.coerce.number().int().min(1).max(720).default(24)
});
var proposalSettingsSchema = z3.object({
  /** New proposals are valid for this many days unless a date is chosen. */
  defaultValidityDays: z3.coerce.number().int().min(1).max(365).default(30),
  /** Printed in the footer of every exported proposal page (e.g. registered office line). */
  footerText: z3.string().trim().max(300).default(""),
  /** Add a "Page x of y" number to exported pages. */
  pageNumbers: z3.boolean().default(true)
});

// src/schemas/masters.ts
import { z as z4 } from "zod";
var divisionEnum2 = z4.enum([DIVISIONS.SOLAR, DIVISIONS.TELECOM]);
var code = (max = 20) => z4.string().trim().toUpperCase().regex(new RegExp(`^[A-Z0-9][A-Z0-9_\\-/.]{0,${max - 1}}$`), "Use capital letters, digits, - _ / or .");
var optionalGstin = z4.string().trim().toUpperCase().refine((v) => v === "" || isValidGstin(v), "Enter a valid 15-character GSTIN").optional().nullable();
var optionalPan = z4.string().trim().toUpperCase().regex(/^[A-Z]{5}\d{4}[A-Z]$/, "Enter a valid PAN").or(z4.literal("")).optional().nullable();
var optionalEmail = z4.string().trim().toLowerCase().email("Enter a valid email").or(z4.literal("")).optional().nullable();
var optionalPhone2 = z4.string().trim().regex(/^(\+91[\s-]?|0)?[6-9]\d{4}[\s-]?\d{5}$|^0\d{2,4}[\s-]?\d{6,8}$/, "Enter a valid phone number").or(z4.literal("")).optional().nullable();
var optionalPincode = z4.union([pincodeSchema, z4.literal("")]).optional().nullable();
var money = z4.coerce.number().min(0).max(999999999999);
var masterListQuerySchema = listQuerySchema.extend({
  status: z4.enum(["active", "inactive", "all"]).default("active")
});
var districtSchema = z4.object({
  stateCode: z4.string().trim().length(2),
  name: z4.string().trim().min(2).max(80),
  isActive: z4.boolean().default(true)
});
var discomSchema = z4.object({
  code: code(20),
  name: z4.string().trim().min(2).max(150),
  stateCode: z4.string().trim().length(2),
  isActive: z4.boolean().default(true)
});
var leadSourceSchema = z4.object({
  name: z4.string().trim().min(2).max(80),
  sortOrder: z4.coerce.number().int().min(0).max(9999).default(100),
  isActive: z4.boolean().default(true)
});
var campaignSchema = z4.object({
  name: z4.string().trim().min(2).max(120),
  sourceId: z4.string().uuid().optional().nullable(),
  division: divisionEnum2.optional().nullable(),
  startDate: z4.coerce.date().optional().nullable(),
  endDate: z4.coerce.date().optional().nullable(),
  budget: money.optional().nullable(),
  notes: optionalString(1e3),
  isActive: z4.boolean().default(true)
}).refine((v) => !v.startDate || !v.endDate || v.endDate >= v.startDate, { path: ["endDate"], message: "End date must be after the start date" });
var uomSchema = z4.object({
  code: code(10),
  name: z4.string().trim().min(1).max(40),
  decimals: z4.coerce.number().int().min(0).max(4).default(0),
  isActive: z4.boolean().default(true)
});
var itemCategorySchema = z4.object({
  code: code(20),
  name: z4.string().trim().min(2).max(80),
  parentId: z4.string().uuid().optional().nullable(),
  isActive: z4.boolean().default(true)
});
var hsnSacSchema = z4.object({
  code: z4.string().trim().regex(/^\d{4,8}$/, "HSN/SAC codes are 4 to 8 digits"),
  description: z4.string().trim().min(2).max(300),
  type: z4.enum(["GOODS", "SERVICES"]),
  defaultTaxRateId: z4.string().uuid().optional().nullable(),
  isActive: z4.boolean().default(true)
});
var taxRateSchema = z4.object({
  name: z4.string().trim().min(2).max(60),
  ratePercent: z4.coerce.number().min(0).max(100),
  cessPercent: z4.coerce.number().min(0).max(100).default(0),
  effectiveFrom: z4.coerce.date(),
  effectiveTo: z4.coerce.date().optional().nullable(),
  sourceUrl: z4.string().trim().url("Enter a valid link").or(z4.literal("")).optional().nullable(),
  lastVerifiedAt: z4.coerce.date().optional().nullable(),
  notes: optionalString(500),
  isActive: z4.boolean().default(true)
}).refine((v) => !v.effectiveTo || v.effectiveTo >= v.effectiveFrom, { path: ["effectiveTo"], message: "Must be on or after the start date" });
var ITEM_TYPES = ["GOODS", "SERVICE"];
var itemSchema = z4.object({
  code: code(30),
  name: z4.string().trim().min(2).max(150),
  description: optionalString(1e3),
  type: z4.enum(ITEM_TYPES).default("GOODS"),
  categoryId: z4.string().uuid({ message: "Choose a category" }),
  uomCode: z4.string().trim().min(1, "Choose a unit").max(10),
  brand: optionalString(80),
  model: optionalString(80),
  specification: optionalString(500),
  hsnSacCode: z4.string().trim().regex(/^\d{4,8}$/, "HSN/SAC codes are 4 to 8 digits").or(z4.literal("")).optional().nullable(),
  taxRateId: z4.string().uuid().optional().nullable(),
  trackSerial: z4.boolean().default(false),
  trackBatch: z4.boolean().default(false),
  warrantyMonths: z4.coerce.number().int().min(0).max(600).optional().nullable(),
  defaultSupplierId: z4.string().uuid().optional().nullable(),
  reorderLevel: z4.coerce.number().min(0).optional().nullable(),
  variantLabel: z4.string().trim().max(60).optional().nullable(),
  variantOptions: z4.array(z4.string().trim().min(1).max(60)).max(20).default([]),
  isActive: z4.boolean().default(true)
});
var itemListQuerySchema = masterListQuerySchema.extend({
  categoryId: z4.string().uuid().optional(),
  type: z4.enum(ITEM_TYPES).optional()
});
var priceListSchema = z4.object({
  name: z4.string().trim().min(2).max(120),
  division: divisionEnum2.optional().nullable(),
  effectiveFrom: z4.coerce.date(),
  effectiveTo: z4.coerce.date().optional().nullable(),
  isDefault: z4.boolean().default(false),
  notes: optionalString(500),
  isActive: z4.boolean().default(true)
}).refine((v) => !v.effectiveTo || v.effectiveTo >= v.effectiveFrom, { path: ["effectiveTo"], message: "Must be on or after the start date" });
var priceListItemSchema = z4.object({
  itemId: z4.string().uuid(),
  rate: z4.coerce.number().min(0).max(999999999),
  /** Internal cost, never printed on customer documents. */
  costRate: z4.coerce.number().min(0).max(999999999).optional().nullable()
});
var priceListItemsSchema = z4.object({ items: z4.array(priceListItemSchema).max(5e3) });
var partyFields = {
  name: z4.string().trim().min(2).max(150),
  gstin: optionalGstin,
  pan: optionalPan,
  contactPerson: optionalString(120),
  phone: optionalPhone2,
  email: optionalEmail,
  addressLine1: optionalString(200),
  addressLine2: optionalString(200),
  city: optionalString(80),
  stateCode: z4.string().trim().length(2).optional().nullable().or(z4.literal("")),
  pincode: optionalPincode,
  isActive: z4.boolean().default(true)
};
var supplierSchema = z4.object({
  code: code(20),
  ...partyFields,
  paymentTermsDays: z4.coerce.number().int().min(0).max(365).optional().nullable(),
  bankName: optionalString(120),
  bankAccountNumber: optionalString(30),
  bankIfsc: z4.string().trim().toUpperCase().regex(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC").or(z4.literal("")).optional().nullable(),
  notes: optionalString(1e3)
});
var telecomClientSchema = z4.object({
  code: code(20),
  ...partyFields,
  billingTerms: optionalString(1e3),
  paymentTermsDays: z4.coerce.number().int().min(0).max(365).optional().nullable()
});
var PARTNER_TYPES = ["INDIVIDUAL", "COMPANY", "DEALER", "CUSTOMER_REFERRAL"];
var BONUS_TYPES = ["PERCENT", "FIXED", "PER_KW"];
var channelPartnerSchema = z4.object({
  code: code(20),
  type: z4.enum(PARTNER_TYPES).default("INDIVIDUAL"),
  ...partyFields,
  bonusType: z4.enum(BONUS_TYPES).optional().nullable(),
  bonusValue: z4.coerce.number().min(0).max(1e7).optional().nullable(),
  bankName: optionalString(120),
  bankAccountNumber: optionalString(30),
  bankIfsc: z4.string().trim().toUpperCase().regex(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC").or(z4.literal("")).optional().nullable(),
  ownerId: z4.string().uuid().optional().nullable(),
  notes: optionalString(1e3)
});

// src/schemas/crm.ts
import { z as z5 } from "zod";
var divisionEnum3 = z5.enum([DIVISIONS.SOLAR, DIVISIONS.TELECOM]);
var indianMobile = z5.string().trim().regex(/^(\+91[\s-]?|0)?[6-9]\d{4}[\s-]?\d{5}$/, "Enter a valid 10-digit Indian mobile number");
var optionalPhone3 = z5.string().trim().regex(/^(\+91[\s-]?|0)?[6-9]\d{4}[\s-]?\d{5}$|^0\d{2,4}[\s-]?\d{6,8}$/, "Enter a valid phone number").or(z5.literal("")).optional().nullable();
var optionalEmail2 = z5.string().trim().toLowerCase().email("Enter a valid email").or(z5.literal("")).optional().nullable();
var optionalPincode2 = z5.union([pincodeSchema, z5.literal("")]).optional().nullable();
var kw = z5.coerce.number().min(0).max(1e5);
var lat = z5.coerce.number().min(-90).max(90);
var lng = z5.coerce.number().min(-180).max(180);
var LEAD_STATUSES = ["NEW", "CONTACTED", "QUALIFIED", "SITE_SURVEY", "PROPOSAL", "NEGOTIATION", "WON", "LOST", "ON_HOLD"];
var LEAD_STATUS_LABELS = {
  NEW: "New",
  CONTACTED: "Contacted",
  QUALIFIED: "Qualified",
  SITE_SURVEY: "Site survey",
  PROPOSAL: "Proposal",
  NEGOTIATION: "Negotiation",
  WON: "Won",
  LOST: "Lost",
  ON_HOLD: "On hold"
};
var LEAD_PIPELINE = ["NEW", "CONTACTED", "QUALIFIED", "SITE_SURVEY", "PROPOSAL", "NEGOTIATION", "WON"];
var SOLAR_TYPES = ["RESIDENTIAL", "COMMERCIAL", "INDUSTRIAL", "INSTITUTIONAL", "GOVERNMENT", "AGRICULTURAL"];
var SOLAR_TYPE_LABELS = {
  RESIDENTIAL: "Residential",
  COMMERCIAL: "Commercial",
  INDUSTRIAL: "Industrial",
  INSTITUTIONAL: "Institutional",
  GOVERNMENT: "Government",
  AGRICULTURAL: "Agricultural"
};
var PHASES = ["SINGLE", "THREE"];
var PRIORITIES = ["LOW", "MEDIUM", "HIGH"];
var leadSchema = z5.object({
  division: divisionEnum3.default("SOLAR"),
  customerName: z5.string().trim().min(2, "Customer name is required").max(150),
  companyName: optionalString(150),
  phone: indianMobile,
  alternatePhone: optionalPhone3,
  email: optionalEmail2,
  addressLine1: optionalString(200),
  addressLine2: optionalString(200),
  city: optionalString(80),
  districtId: z5.string().uuid().optional().nullable(),
  stateCode: z5.string().trim().length(2, "Choose a state"),
  pincode: optionalPincode2,
  latitude: lat.optional().nullable(),
  longitude: lng.optional().nullable(),
  solarType: z5.enum(SOLAR_TYPES).optional().nullable(),
  phase: z5.enum(PHASES).optional().nullable(),
  requiredKw: kw.optional().nullable(),
  contractLoadKw: kw.optional().nullable(),
  monthlyBill: z5.coerce.number().min(0).max(1e8).optional().nullable(),
  discomId: z5.string().uuid().optional().nullable(),
  consumerNumber: optionalString(40),
  requirement: optionalString(2e3),
  estimatedValue: z5.coerce.number().min(0).max(1e10).optional().nullable(),
  sourceId: z5.string().uuid({ message: "Choose a lead source" }),
  campaignId: z5.string().uuid().optional().nullable(),
  channelPartnerId: z5.string().uuid().optional().nullable(),
  referredByCustomerId: z5.string().uuid().optional().nullable(),
  telecomClientId: z5.string().uuid().optional().nullable(),
  ownerId: z5.string().uuid().optional().nullable(),
  priority: z5.enum(PRIORITIES).default("MEDIUM"),
  nextFollowUpAt: z5.coerce.date().optional().nullable()
});
var updateLeadSchema = leadSchema.partial().omit({ ownerId: true });
var leadListQuerySchema = listQuerySchema.extend({
  status: z5.enum([...LEAD_STATUSES, "OPEN", "ALL"]).default("OPEN"),
  division: divisionEnum3.optional(),
  ownerId: z5.string().uuid().optional(),
  sourceId: z5.string().uuid().optional(),
  channelPartnerId: z5.string().uuid().optional(),
  stateCode: z5.string().length(2).optional(),
  districtId: z5.string().uuid().optional(),
  priority: z5.enum(PRIORITIES).optional(),
  followUp: z5.enum(["overdue", "today", "none"]).optional(),
  createdFrom: z5.coerce.date().optional(),
  createdTo: z5.coerce.date().optional()
});
var leadStatusChangeSchema = z5.object({
  status: z5.enum(LEAD_STATUSES),
  reason: z5.string().trim().max(1e3).optional().nullable()
}).refine((v) => v.status !== "LOST" || v.reason && v.reason.length >= 3, { path: ["reason"], message: "Give a reason for losing the lead" });
var leadAssignSchema = z5.object({
  ownerId: z5.string().uuid(),
  reason: z5.string().trim().max(500).optional().nullable()
});
var duplicateCheckSchema = z5.object({
  phone: z5.string().trim().max(20).optional(),
  email: z5.string().trim().max(254).optional(),
  consumerNumber: z5.string().trim().max(40).optional(),
  excludeLeadId: z5.string().uuid().optional()
});
var ACTIVITY_TYPES = ["CALL", "MEETING", "SITE_VISIT", "EMAIL", "WHATSAPP", "NOTE"];
var SYSTEM_ACTIVITY_TYPES = ["STATUS_CHANGE", "ASSIGNMENT", "CONVERSION", "SYSTEM"];
var ACTIVITY_TYPE_LABELS = {
  CALL: "Call",
  MEETING: "Meeting",
  SITE_VISIT: "Site visit",
  EMAIL: "Email",
  WHATSAPP: "WhatsApp",
  NOTE: "Note",
  STATUS_CHANGE: "Status change",
  ASSIGNMENT: "Assignment",
  CONVERSION: "Conversion",
  SYSTEM: "System"
};
var ACTIVITY_OUTCOMES = [
  "Interested",
  "Not interested",
  "Call back later",
  "No answer",
  "Switched off / unreachable",
  "Wrong number",
  "Requested quotation",
  "Site visit scheduled",
  "Negotiating",
  "Decision pending"
];
var activitySchema = z5.object({
  type: z5.enum(ACTIVITY_TYPES),
  direction: z5.enum(["INBOUND", "OUTBOUND"]).optional().nullable(),
  subject: optionalString(200),
  body: z5.string().trim().min(2, "Write what happened").max(5e3),
  outcome: optionalString(80),
  occurredAt: z5.coerce.date().optional(),
  durationMinutes: z5.coerce.number().int().min(0).max(1440).optional().nullable(),
  nextAction: optionalString(300),
  /** Creates a follow-up assigned to the lead/customer owner (or the author). */
  nextFollowUpAt: z5.coerce.date().optional().nullable(),
  /** When correcting an earlier entry, the original stays and this one links to it. */
  amendsActivityId: z5.string().uuid().optional().nullable()
}).refine((v) => !v.nextFollowUpAt || v.nextFollowUpAt.getTime() > Date.now() - 6e4, {
  path: ["nextFollowUpAt"],
  message: "Next follow-up must be in the future"
});
var followUpSchema = z5.object({
  title: z5.string().trim().min(2).max(200),
  notes: optionalString(1e3),
  dueAt: z5.coerce.date(),
  assignedToId: z5.string().uuid().optional().nullable()
});
var completeFollowUpSchema = z5.object({
  /** Logged as an activity on the lead/customer so the outcome is in the timeline. */
  outcome: z5.string().trim().min(2, "Write the outcome").max(2e3),
  activityType: z5.enum(ACTIVITY_TYPES).default("CALL"),
  nextFollowUpAt: z5.coerce.date().optional().nullable()
});
var followUpListQuerySchema = listQuerySchema.extend({
  scope: z5.enum(["mine", "team"]).default("mine"),
  status: z5.enum(["OPEN", "DONE", "CANCELLED", "ALL"]).default("OPEN"),
  due: z5.enum(["overdue", "today", "upcoming", "all"]).default("all"),
  assignedToId: z5.string().uuid().optional()
});
var CUSTOMER_TYPES = ["INDIVIDUAL", "BUSINESS", "GOVERNMENT"];
var ADDRESS_TYPES = ["BILLING", "SITE", "SHIPPING"];
var optionalGstin2 = z5.string().trim().toUpperCase().refine((v) => v === "" || isValidGstin(v), "Enter a valid 15-character GSTIN").optional().nullable();
var customerSchema = z5.object({
  type: z5.enum(CUSTOMER_TYPES).default("INDIVIDUAL"),
  name: z5.string().trim().min(2, "Name is required").max(150),
  legalName: optionalString(200),
  gstin: optionalGstin2,
  pan: z5.string().trim().toUpperCase().regex(/^[A-Z]{5}\d{4}[A-Z]$/, "Enter a valid PAN").or(z5.literal("")).optional().nullable(),
  phone: indianMobile,
  alternatePhone: optionalPhone3,
  email: optionalEmail2,
  addressLine1: z5.string().trim().min(2, "Address is required").max(200),
  addressLine2: optionalString(200),
  city: optionalString(80),
  districtId: z5.string().uuid().optional().nullable(),
  stateCode: z5.string().trim().length(2, "Choose a state"),
  pincode: optionalPincode2,
  channelPartnerId: z5.string().uuid().optional().nullable(),
  ownerId: z5.string().uuid().optional().nullable(),
  notes: optionalString(2e3)
});
var updateCustomerSchema = customerSchema.partial();
var customerListQuerySchema = listQuerySchema.extend({
  status: z5.enum(["active", "inactive", "all"]).default("active"),
  type: z5.enum(CUSTOMER_TYPES).optional(),
  stateCode: z5.string().length(2).optional(),
  ownerId: z5.string().uuid().optional()
});
var contactSchema = z5.object({
  name: z5.string().trim().min(2).max(120),
  designation: optionalString(80),
  phone: optionalPhone3,
  email: optionalEmail2,
  isPrimary: z5.boolean().default(false)
});
var customerAddressSchema = z5.object({
  type: z5.enum(ADDRESS_TYPES).default("SITE"),
  label: optionalString(80),
  addressLine1: z5.string().trim().min(2).max(200),
  addressLine2: optionalString(200),
  city: optionalString(80),
  districtId: z5.string().uuid().optional().nullable(),
  stateCode: z5.string().trim().length(2),
  pincode: optionalPincode2,
  latitude: lat.optional().nullable(),
  longitude: lng.optional().nullable(),
  isDefault: z5.boolean().default(false)
});
var convertLeadSchema = z5.object({
  /** Link to an existing customer instead of creating one (e.g. repeat customer). */
  existingCustomerId: z5.string().uuid().optional().nullable(),
  customer: customerSchema.optional(),
  project: z5.object({
    name: z5.string().trim().min(2).max(150),
    startDate: z5.coerce.date().optional().nullable(),
    targetDate: z5.coerce.date().optional().nullable(),
    contractValue: z5.coerce.number().min(0).optional().nullable(),
    managerId: z5.string().uuid().optional().nullable(),
    branchId: z5.string().uuid().optional().nullable()
  }),
  site: z5.object({
    name: z5.string().trim().min(2).max(150),
    useLeadAddress: z5.boolean().default(true)
  })
}).refine((v) => !!v.existingCustomerId || !!v.customer, { path: ["customer"], message: "Choose an existing customer or enter new customer details" });

// src/schemas/projects.ts
import { z as z6 } from "zod";
var divisionEnum4 = z6.enum([DIVISIONS.SOLAR, DIVISIONS.TELECOM]);
var optionalPincode3 = z6.union([pincodeSchema, z6.literal("")]).optional().nullable();
var kw2 = z6.coerce.number().min(0).max(1e5);
var PROJECT_STATUSES = ["PLANNING", "ACTIVE", "ON_HOLD", "COMPLETED", "CANCELLED", "CLOSED"];
var PROJECT_STATUS_LABELS = {
  PLANNING: "Planning",
  ACTIVE: "Active",
  ON_HOLD: "On hold",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  CLOSED: "Closed"
};
var SITE_STATUSES = ["NEW", "SURVEY", "DESIGN", "APPROVAL", "INSTALLATION", "COMMISSIONED", "HANDED_OVER", "ON_HOLD", "CANCELLED"];
var SITE_STATUS_LABELS = {
  NEW: "New",
  SURVEY: "Survey",
  DESIGN: "Design",
  APPROVAL: "Approvals",
  INSTALLATION: "Installation",
  COMMISSIONED: "Commissioned",
  HANDED_OVER: "Handed over",
  ON_HOLD: "On hold",
  CANCELLED: "Cancelled"
};
var projectSchema = z6.object({
  division: divisionEnum4,
  name: z6.string().trim().min(2, "Project name is required").max(150),
  customerId: z6.string().uuid({ message: "Choose a customer" }),
  telecomClientId: z6.string().uuid().optional().nullable(),
  managerId: z6.string().uuid().optional().nullable(),
  branchId: z6.string().uuid().optional().nullable(),
  startDate: z6.coerce.date().optional().nullable(),
  targetDate: z6.coerce.date().optional().nullable(),
  contractValue: z6.coerce.number().min(0).max(1e10).optional().nullable(),
  description: optionalString(2e3)
}).refine((v) => !v.startDate || !v.targetDate || v.targetDate >= v.startDate, { path: ["targetDate"], message: "Target date must be after the start date" });
var projectListQuerySchema = listQuerySchema.extend({
  status: z6.enum([...PROJECT_STATUSES, "OPEN", "ALL"]).default("OPEN"),
  division: divisionEnum4.optional(),
  customerId: z6.string().uuid().optional(),
  managerId: z6.string().uuid().optional()
});
var projectStatusSchema = z6.object({
  status: z6.enum(PROJECT_STATUSES),
  reason: z6.string().trim().max(1e3).optional().nullable()
}).refine((v) => !["CANCELLED", "CLOSED", "ON_HOLD"].includes(v.status) || v.reason && v.reason.length >= 3, {
  path: ["reason"],
  message: "Give a reason for this status"
});
var siteSchema = z6.object({
  name: z6.string().trim().min(2, "Site name is required").max(150),
  siteCode: z6.string().trim().toUpperCase().regex(/^[A-Z0-9][A-Z0-9_\-/]{1,39}$/, "Use capital letters, digits, - _ or /").optional().nullable().or(z6.literal("")),
  addressLine1: z6.string().trim().min(2, "Address is required").max(200),
  addressLine2: optionalString(200),
  city: optionalString(80),
  districtId: z6.string().uuid().optional().nullable(),
  stateCode: z6.string().trim().length(2, "Choose a state"),
  pincode: optionalPincode3,
  latitude: z6.coerce.number().min(-90).max(90).optional().nullable(),
  longitude: z6.coerce.number().min(-180).max(180).optional().nullable(),
  solarType: z6.enum(SOLAR_TYPES).optional().nullable(),
  capacityKw: kw2.optional().nullable(),
  phase: z6.enum(PHASES).optional().nullable(),
  contractLoadKw: kw2.optional().nullable(),
  discomId: z6.string().uuid().optional().nullable(),
  consumerNumber: optionalString(40),
  netMeterNumber: optionalString(40),
  /** Telecom: client's site / tower identifier. */
  clientSiteId: optionalString(60),
  scope: optionalString(2e3),
  targetDate: z6.coerce.date().optional().nullable()
});
var siteStatusSchema = z6.object({
  status: z6.enum(SITE_STATUSES),
  reason: z6.string().trim().max(1e3).optional().nullable()
}).refine((v) => !["CANCELLED", "ON_HOLD"].includes(v.status) || v.reason && v.reason.length >= 3, {
  path: ["reason"],
  message: "Give a reason for this status"
});
var siteListQuerySchema = listQuerySchema.extend({
  status: z6.enum([...SITE_STATUSES, "ALL"]).default("ALL"),
  division: divisionEnum4.optional(),
  stateCode: z6.string().length(2).optional(),
  districtId: z6.string().uuid().optional(),
  projectId: z6.string().uuid().optional()
});

// src/schemas/imports.ts
import { z as z7 } from "zod";
var IMPORT_TYPES = {
  LEADS: {
    label: "Leads",
    fields: [
      { key: "customerName", label: "Customer name", required: true },
      { key: "phone", label: "Mobile number", required: true },
      { key: "email", label: "Email" },
      { key: "companyName", label: "Company" },
      { key: "addressLine1", label: "Address" },
      { key: "city", label: "City / village" },
      { key: "district", label: "District (name)" },
      { key: "state", label: "State (name or code)", required: true },
      { key: "pincode", label: "PIN code" },
      { key: "division", label: "Division (Solar/Telecom)" },
      { key: "solarType", label: "Solar type" },
      { key: "phase", label: "Phase (Single/Three)" },
      { key: "requiredKw", label: "Required kW" },
      { key: "contractLoadKw", label: "Contract load kW" },
      { key: "consumerNumber", label: "Consumer number" },
      { key: "source", label: "Lead source (name)", required: true },
      { key: "ownerEmail", label: "Owner email" },
      { key: "requirement", label: "Requirement / notes" }
    ]
  },
  CUSTOMERS: {
    label: "Customers",
    fields: [
      { key: "name", label: "Name", required: true },
      { key: "type", label: "Type (Individual/Business/Government)" },
      { key: "phone", label: "Mobile number", required: true },
      { key: "email", label: "Email" },
      { key: "gstin", label: "GSTIN" },
      { key: "pan", label: "PAN" },
      { key: "addressLine1", label: "Address", required: true },
      { key: "city", label: "City / village" },
      { key: "district", label: "District (name)" },
      { key: "state", label: "State (name or code)", required: true },
      { key: "pincode", label: "PIN code" },
      { key: "notes", label: "Notes" }
    ]
  },
  ITEMS: {
    label: "Items",
    fields: [
      { key: "code", label: "Item code", required: true },
      { key: "name", label: "Name", required: true },
      { key: "category", label: "Category (code or name)", required: true },
      { key: "uom", label: "Unit code", required: true },
      { key: "type", label: "Type (Goods/Service)" },
      { key: "brand", label: "Brand" },
      { key: "model", label: "Model" },
      { key: "specification", label: "Specification" },
      { key: "hsnSacCode", label: "HSN/SAC" },
      { key: "warrantyMonths", label: "Warranty (months)" },
      { key: "trackSerial", label: "Track serial numbers (Yes/No)" }
    ]
  },
  SITES: {
    label: "Sites",
    fields: [
      { key: "projectNumber", label: "Project number", required: true },
      { key: "name", label: "Site name", required: true },
      { key: "siteCode", label: "Site code" },
      { key: "addressLine1", label: "Address", required: true },
      { key: "city", label: "City / village" },
      { key: "district", label: "District (name)" },
      { key: "state", label: "State (name or code)", required: true },
      { key: "pincode", label: "PIN code" },
      { key: "latitude", label: "Latitude" },
      { key: "longitude", label: "Longitude" },
      { key: "capacityKw", label: "Capacity kW" },
      { key: "contractLoadKw", label: "Contract load kW" },
      { key: "consumerNumber", label: "Consumer number" },
      { key: "netMeterNumber", label: "Net meter number" },
      { key: "clientSiteId", label: "Client site ID (telecom)" }
    ]
  },
  OPENING_STOCK: {
    label: "Opening stock",
    fields: [
      { key: "itemCode", label: "Item code", required: true },
      { key: "location", label: "Store (location code)", required: true },
      { key: "qty", label: "Quantity", required: true },
      { key: "unitCost", label: "Unit cost (\u20B9)", required: true },
      { key: "division", label: "Division (Solar/Telecom)" },
      { key: "batchNo", label: "Batch number" },
      { key: "serials", label: "Serial numbers (comma separated)" }
    ]
  }
};
var IMPORT_TYPE_KEYS = Object.keys(IMPORT_TYPES);
var IMPORT_PERMISSIONS = {
  LEADS: PERMISSIONS.LEADS_CREATE,
  CUSTOMERS: PERMISSIONS.CUSTOMERS_CREATE,
  ITEMS: PERMISSIONS.ITEMS_MANAGE,
  SITES: PERMISSIONS.PROJECTS_CREATE,
  OPENING_STOCK: PERMISSIONS.INVENTORY_ADJUST
};
var importSignOffSchema = z7.object({
  controlCount: z7.coerce.number().int().min(0).max(1e7).nullable().optional(),
  controlAmount: z7.coerce.number().min(-1e12).max(1e12).nullable().optional(),
  controlQty: z7.coerce.number().min(-1e12).max(1e12).nullable().optional(),
  acceptExceptions: z7.boolean(),
  remarks: z7.string().trim().min(10, "Explain the reconciliation and any differences").max(2e3)
});
var importMappingSchema = z7.object({
  /** Map of target field key → source column header. */
  mapping: z7.record(z7.string(), z7.string())
});
var IMPORT_MAX_ROWS = 2e4;

// src/schemas/proposals.ts
import { z as z8 } from "zod";
var divisionEnum5 = z8.enum([DIVISIONS.SOLAR, DIVISIONS.TELECOM]);
var id = () => z8.string().min(1).max(40);
var PROPOSAL_STATUSES = ["DRAFT", "IN_REVIEW", "APPROVED", "SHARED", "NEGOTIATION", "ACCEPTED", "REJECTED", "EXPIRED", "SUPERSEDED"];
var PROPOSAL_STATUS_LABELS = {
  DRAFT: "Draft",
  IN_REVIEW: "In review",
  APPROVED: "Approved",
  SHARED: "Shared",
  NEGOTIATION: "Negotiation",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  EXPIRED: "Expired",
  SUPERSEDED: "Superseded"
};
var VERSION_STATUSES = ["DRAFT", "IN_REVIEW", "APPROVED", "REJECTED", "SUPERSEDED"];
var PROPOSAL_SECTIONS = [
  "COVER",
  "EXECUTIVE_SUMMARY",
  "COMPANY_PROFILE",
  "CUSTOMER_DETAILS",
  "SITE_SURVEY",
  "TECHNICAL_PROPOSAL",
  "BILL_OF_MATERIALS",
  "PRICING",
  "STRUCTURE",
  "ROI",
  "SCOPE",
  "TERMS",
  "WARRANTY",
  "ANNEXURES"
];
var PROPOSAL_SECTION_LABELS = {
  COVER: "Cover",
  EXECUTIVE_SUMMARY: "Executive summary",
  COMPANY_PROFILE: "Company profile",
  CUSTOMER_DETAILS: "Customer details",
  SITE_SURVEY: "Site survey",
  TECHNICAL_PROPOSAL: "Technical proposal",
  BILL_OF_MATERIALS: "Bill of materials",
  PRICING: "Pricing",
  STRUCTURE: "Structure",
  ROI: "ROI assumptions",
  SCOPE: "Scope of work",
  TERMS: "Terms & conditions",
  WARRANTY: "Warranty",
  ANNEXURES: "Annexures"
};
var PAGE_KINDS = ["NATIVE", "PDF_ORIGINAL", "PDF_OCR"];
var PAGE_KIND_LABELS = {
  NATIVE: "Editable",
  PDF_ORIGINAL: "Original PDF page",
  PDF_OCR: "Scanned page (OCR text)"
};
var PAGE_LAYOUTS = ["single", "twoColumn", "cover"];
var align = z8.enum(["left", "center", "right"]).default("left");
var column = z8.enum(["left", "right"]).optional();
var base = { id: id(), column };
var headingBlock = z8.object({ ...base, type: z8.literal("heading"), text: z8.string().max(300), level: z8.union([z8.literal(1), z8.literal(2), z8.literal(3)]).default(2), align });
var richTextBlock = z8.object({ ...base, type: z8.literal("richText"), html: z8.string().max(5e4) });
var imageBlock = z8.object({
  ...base,
  type: z8.literal("image"),
  fileId: z8.string().uuid().nullable(),
  caption: z8.string().max(300).default(""),
  width: z8.enum(["full", "half", "third"]).default("full"),
  align
});
var tableBlock = z8.object({
  ...base,
  type: z8.literal("table"),
  caption: z8.string().max(300).default(""),
  headers: z8.array(z8.string().max(200)).max(12),
  rows: z8.array(z8.array(z8.string().max(1e3)).max(12)).max(200),
  striped: z8.boolean().default(true)
});
var keyValueBlock = z8.object({
  ...base,
  type: z8.literal("keyValue"),
  title: z8.string().max(200).default(""),
  items: z8.array(z8.object({ label: z8.string().max(120), value: z8.string().max(500) })).max(40)
});
var pricingBlock = z8.object({
  ...base,
  type: z8.literal("pricing"),
  title: z8.string().max(200).default("Commercial offer"),
  showDiscount: z8.boolean().default(true),
  showTax: z8.boolean().default(true),
  showOptional: z8.boolean().default(true),
  showAmountInWords: z8.boolean().default(true)
});
var bomBlock = z8.object({ ...base, type: z8.literal("bom"), title: z8.string().max(200).default("Bill of materials"), groupByType: z8.boolean().default(true) });
var paymentScheduleBlock = z8.object({ ...base, type: z8.literal("paymentSchedule"), title: z8.string().max(200).default("Payment terms") });
var productCardBlock = z8.object({
  ...base,
  type: z8.literal("productCard"),
  itemId: z8.string().uuid().nullable(),
  imageFileId: z8.string().uuid().nullable().default(null),
  highlights: z8.array(z8.string().max(200)).max(10).default([])
});
var chartBlock = z8.object({
  ...base,
  type: z8.literal("chart"),
  chartType: z8.enum(["bar", "line"]).default("bar"),
  title: z8.string().max(200).default(""),
  labels: z8.array(z8.string().max(40)).max(36),
  series: z8.array(z8.object({ name: z8.string().max(60), values: z8.array(z8.number()).max(36) })).max(4),
  unit: z8.string().max(20).default(""),
  /** Values are estimates and must say so on the page (BRD §6.4). */
  isEstimate: z8.boolean().default(true)
});
var signatureBlock = z8.object({
  ...base,
  type: z8.literal("signature"),
  label: z8.string().max(120).default("For {{company.name}}"),
  name: z8.string().max(120).default(""),
  designation: z8.string().max(120).default(""),
  useCompanySignature: z8.boolean().default(true),
  includeCustomerSignature: z8.boolean().default(true)
});
var spacerBlock = z8.object({ ...base, type: z8.literal("spacer"), height: z8.number().int().min(4).max(400).default(24) });
var dividerBlock = z8.object({ ...base, type: z8.literal("divider") });
var blockSchema = z8.discriminatedUnion("type", [
  headingBlock,
  richTextBlock,
  imageBlock,
  tableBlock,
  keyValueBlock,
  pricingBlock,
  bomBlock,
  paymentScheduleBlock,
  productCardBlock,
  chartBlock,
  signatureBlock,
  spacerBlock,
  dividerBlock
]);
var BLOCK_TYPE_LABELS = {
  heading: "Heading",
  richText: "Text",
  image: "Image",
  table: "Table",
  keyValue: "Details list",
  pricing: "Pricing table",
  bom: "Bill of materials",
  paymentSchedule: "Payment schedule",
  productCard: "Product card",
  chart: "Chart",
  signature: "Signature",
  spacer: "Spacer",
  divider: "Divider"
};
var pageContentSchema = z8.object({
  section: z8.enum(PROPOSAL_SECTIONS).default("TECHNICAL_PROPOSAL"),
  title: z8.string().trim().max(200).default(""),
  layout: z8.enum(PAGE_LAYOUTS).default("single"),
  orientation: z8.enum(["portrait", "landscape"]).default("portrait"),
  blocks: z8.array(blockSchema).max(80).default([]),
  showHeader: z8.boolean().default(true),
  showFooter: z8.boolean().default(true),
  includeInExport: z8.boolean().default(true),
  locked: z8.boolean().default(false),
  internalNotes: z8.string().max(2e3).nullable().optional()
});
var updatePageSchema = pageContentSchema.partial().extend({ rotation: z8.union([z8.literal(0), z8.literal(90), z8.literal(180), z8.literal(270)]).optional() });
var reorderPagesSchema = z8.object({ pageIds: z8.array(z8.string().uuid()).min(1).max(5e3) });
var insertPageSchema = pageContentSchema.extend({ afterPageId: z8.string().uuid().nullable().optional() });
var LINE_TYPES = ["EQUIPMENT", "STRUCTURE", "ELECTRICAL", "INSTALLATION", "CIVIL", "TRANSPORT", "SERVICE", "OTHER"];
var LINE_TYPE_LABELS = {
  EQUIPMENT: "Equipment",
  STRUCTURE: "Structure",
  ELECTRICAL: "Electrical works",
  INSTALLATION: "Installation",
  CIVIL: "Civil works",
  TRANSPORT: "Transport",
  SERVICE: "Services",
  OTHER: "Other"
};
var proposalLineSchema = z8.object({
  itemId: z8.string().uuid().nullable().optional(),
  lineType: z8.enum(LINE_TYPES).default("EQUIPMENT"),
  description: z8.string().trim().min(1, "Describe the line").max(500),
  hsnSac: z8.string().trim().max(8).nullable().optional(),
  qty: z8.coerce.number().positive("Quantity must be more than zero").max(1e7),
  uom: z8.string().trim().min(1).max(10),
  rate: z8.coerce.number().min(0).max(1e9),
  /** Price-list rate at the time the line was added; a different `rate` is an override. */
  listRate: z8.coerce.number().min(0).nullable().optional(),
  discountPercent: z8.coerce.number().min(0).max(100).default(0),
  taxPercent: z8.coerce.number().min(0).max(100).default(0),
  costRate: z8.coerce.number().min(0).nullable().optional(),
  isOptional: z8.boolean().default(false),
  overrideReason: optionalString(500)
});
var paymentMilestoneSchema = z8.object({
  label: z8.string().trim().min(2).max(200),
  percent: z8.coerce.number().min(0).max(100),
  trigger: optionalString(200)
});
var pricingSchema = z8.object({
  lines: z8.array(proposalLineSchema).max(500),
  milestones: z8.array(paymentMilestoneSchema).max(20).default([]),
  /** Extra flat discount on the whole offer, before tax. */
  overallDiscount: z8.coerce.number().min(0).default(0),
  notes: optionalString(2e3)
}).refine((v) => v.milestones.length === 0 || Math.abs(v.milestones.reduce((s, m) => s + m.percent, 0) - 100) < 0.01, {
  path: ["milestones"],
  message: "Payment milestones must add up to 100%"
});
var createProposalSchema = z8.object({
  title: z8.string().trim().min(2, "Give the proposal a title").max(200),
  division: divisionEnum5.default("SOLAR"),
  leadId: z8.string().uuid().nullable().optional(),
  customerId: z8.string().uuid().nullable().optional(),
  projectId: z8.string().uuid().nullable().optional(),
  siteId: z8.string().uuid().nullable().optional(),
  templateId: z8.string().uuid().nullable().optional(),
  priceListId: z8.string().uuid().nullable().optional(),
  validUntil: z8.coerce.date().nullable().optional()
}).refine((v) => v.leadId || v.customerId, { path: ["leadId"], message: "Link the proposal to a lead or a customer" });
var updateProposalSchema = z8.object({
  title: z8.string().trim().min(2).max(200).optional(),
  priceListId: z8.string().uuid().nullable().optional(),
  validUntil: z8.coerce.date().nullable().optional(),
  ownerId: z8.string().uuid().optional()
});
var proposalListQuerySchema = listQuerySchema.extend({
  status: z8.enum([...PROPOSAL_STATUSES, "OPEN", "ALL"]).default("ALL"),
  division: divisionEnum5.optional(),
  ownerId: z8.string().uuid().optional(),
  leadId: z8.string().uuid().optional(),
  customerId: z8.string().uuid().optional()
});
var newVersionSchema = z8.object({
  label: optionalString(120),
  /** Copy from this version; defaults to the latest. Used to restore an earlier version. */
  fromVersionId: z8.string().uuid().nullable().optional()
});
var proposalDecisionSchema = z8.object({ comment: optionalString(1e3) });
var proposalResponseSchema = z8.object({
  outcome: z8.enum(["NEGOTIATION", "ACCEPTED", "REJECTED"]),
  comment: optionalString(1e3)
}).refine((v) => v.outcome !== "REJECTED" || v.comment && v.comment.length >= 3, { path: ["comment"], message: "Say why the customer rejected it" });
var shareProposalSchema = z8.object({
  method: z8.enum(["DOWNLOAD", "EMAIL", "WHATSAPP", "IN_PERSON"]),
  recipient: optionalString(254),
  note: optionalString(1e3)
});
var templateSchema = z8.object({
  name: z8.string().trim().min(2).max(120),
  description: optionalString(500),
  division: divisionEnum5.nullable().optional(),
  isActive: z8.boolean().default(true)
});
var templatePagesSchema = z8.object({ pages: z8.array(pageContentSchema).max(200) });
var REUSABLE_CATEGORIES = ["COMPANY", "TERMS", "WARRANTY", "PRODUCT", "SIGNATURE", "SCOPE", "OTHER"];
var reusableBlockSchema = z8.object({
  name: z8.string().trim().min(2).max(120),
  category: z8.enum(REUSABLE_CATEGORIES),
  block: blockSchema,
  isActive: z8.boolean().default(true)
});
var AI_PROVIDERS = ["none", "anthropic"];
var AI_PROVIDER_LABELS = { none: "Disabled", anthropic: "Anthropic Claude" };
var AI_DEFAULT_MODEL = "claude-opus-5-5";
var AI_FEATURES = ["extraction", "drafting", "layout", "bom", "followUp", "dprSummary", "insights", "copilot"];
var AI_FEATURE_LABELS = {
  extraction: "PDF data extraction",
  drafting: "Proposal drafting",
  layout: "Proposal layout review",
  bom: "Material plan draft from design",
  followUp: "CRM follow-up assistant",
  dprSummary: "Daily report summaries",
  insights: "Forecast and ROI explanations",
  copilot: "Management copilot"
};
var aiSettingsSchema = z8.object({
  enabled: z8.boolean().default(false),
  provider: z8.enum(AI_PROVIDERS).default("none"),
  model: z8.string().trim().max(120).default(AI_DEFAULT_MODEL),
  features: z8.object({
    extraction: z8.boolean().default(true),
    drafting: z8.boolean().default(true),
    layout: z8.boolean().default(true),
    bom: z8.boolean().default(true),
    followUp: z8.boolean().default(true),
    dprSummary: z8.boolean().default(true),
    insights: z8.boolean().default(true),
    copilot: z8.boolean().default(true)
  }).default({}),
  /** Pricing guardrails (rule-based, always on, independent of AI). */
  minMarginPercent: z8.coerce.number().min(-100).max(100).default(12),
  maxDiscountPercent: z8.coerce.number().min(0).max(100).default(10)
});
var aiSettingsUpdateSchema = aiSettingsSchema.extend({
  apiKey: z8.string().trim().max(400).optional(),
  /** Set to true to remove the stored key. */
  clearApiKey: z8.boolean().optional()
});
var aiRequestListSchema = listQuerySchema.extend({ feature: z8.enum(AI_FEATURES).optional(), status: z8.enum(["SUCCESS", "FAILED", "REFUSED"]).optional() });
var PROPOSAL_TOKENS = [
  { key: "proposal.number", label: "Proposal number" },
  { key: "proposal.title", label: "Proposal title" },
  { key: "proposal.date", label: "Proposal date" },
  { key: "proposal.validUntil", label: "Valid until" },
  { key: "proposal.version", label: "Version number" },
  { key: "proposal.grandTotal", label: "Grand total" },
  { key: "proposal.grandTotalWords", label: "Grand total in words" },
  { key: "customer.name", label: "Customer name" },
  { key: "customer.company", label: "Customer company" },
  { key: "customer.phone", label: "Customer phone" },
  { key: "customer.email", label: "Customer email" },
  { key: "customer.address", label: "Customer address" },
  { key: "customer.gstin", label: "Customer GSTIN" },
  { key: "site.name", label: "Site name" },
  { key: "site.address", label: "Site address" },
  { key: "site.capacityKw", label: "Capacity (kW)" },
  { key: "site.discom", label: "DISCOM" },
  { key: "site.consumerNumber", label: "Consumer number" },
  { key: "site.contractLoadKw", label: "Contract load (kW)" },
  { key: "company.name", label: "Company name" },
  { key: "company.address", label: "Company address" },
  { key: "company.gstin", label: "Company GSTIN" },
  { key: "company.phone", label: "Company phone" },
  { key: "company.email", label: "Company email" },
  { key: "company.website", label: "Company website" },
  { key: "owner.name", label: "Sales owner name" },
  { key: "owner.phone", label: "Sales owner phone" },
  { key: "owner.email", label: "Sales owner email" }
];
var TOKEN_PATTERN = /\{\{\s*([a-zA-Z]+\.[a-zA-Z]+)\s*\}\}/g;
function fillTokens(text, values, missing = "\u2014") {
  const miss = /* @__PURE__ */ new Set();
  const out = text.replace(TOKEN_PATTERN, (_m, key) => {
    const v = values[key];
    if (v == null || v === "") {
      miss.add(key);
      return missing;
    }
    return v;
  });
  return { text: out, missing: [...miss] };
}
var aiDraftRequestSchema = z8.object({
  sections: z8.array(z8.enum(["EXECUTIVE_SUMMARY", "COMPANY_PROFILE", "CUSTOMER_DETAILS", "TECHNICAL_PROPOSAL", "SCOPE"])).min(1).max(5),
  notes: optionalString(2e3)
});
var aiExtractRequestSchema = z8.object({ sourceFileId: z8.string().uuid() });
var pageBulkSchema = z8.object({
  pageIds: z8.array(z8.string().uuid()).min(1).max(5e3),
  action: z8.enum(["include", "exclude", "delete", "lock", "unlock"])
});
var duplicatePageSchema = z8.object({ count: z8.coerce.number().int().min(1).max(20).default(1) });

// src/pricing.ts
import Decimal2 from "decimal.js";
var r2 = (d) => d.toDecimalPlaces(2, Decimal2.ROUND_HALF_UP);
function priceProposal(lines, overallDiscount = 0) {
  const priced = lines.map((l) => {
    const gross2 = r2(new Decimal2(l.qty).times(l.rate));
    const discountAmount = r2(gross2.times(l.discountPercent ?? 0).div(100));
    const taxable2 = gross2.minus(discountAmount);
    return { l, gross: gross2, discountAmount, taxable: taxable2 };
  });
  const included = priced.filter((p) => !p.l.isOptional);
  const taxableBeforeOverall = included.reduce((s, p) => s.plus(p.taxable), new Decimal2(0));
  const overall = Decimal2.min(new Decimal2(overallDiscount || 0), taxableBeforeOverall);
  let remaining = overall;
  const shares = /* @__PURE__ */ new Map();
  included.forEach((p, i) => {
    const share = i === included.length - 1 || taxableBeforeOverall.isZero() ? remaining : r2(overall.times(p.taxable).div(taxableBeforeOverall));
    shares.set(priced.indexOf(p), share);
    remaining = remaining.minus(share);
  });
  const out = priced.map((p, idx) => {
    const share = shares.get(idx) ?? new Decimal2(0);
    const taxable2 = p.taxable.minus(share);
    const taxAmount = r2(taxable2.times(p.l.taxPercent ?? 0).div(100));
    const cost2 = p.l.costRate == null ? null : r2(new Decimal2(p.l.qty).times(p.l.costRate));
    return {
      ...p.l,
      gross: p.gross.toFixed(2),
      discountAmount: p.discountAmount.plus(share).toFixed(2),
      taxable: taxable2.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
      total: taxable2.plus(taxAmount).toFixed(2),
      cost: cost2?.toFixed(2) ?? null,
      isOverride: p.l.listRate != null && !new Decimal2(p.l.listRate).equals(p.l.rate)
    };
  });
  const inc = out.filter((l) => !l.isOptional);
  const sum = (arr, f) => arr.reduce((s, l) => s.plus(f(l)), new Decimal2(0));
  const taxable = sum(inc, (l) => l.taxable);
  const tax = sum(inc, (l) => l.taxAmount);
  const allCosted = inc.length > 0 && inc.every((l) => l.cost != null);
  const cost = allCosted ? sum(inc, (l) => l.cost) : null;
  const byType = /* @__PURE__ */ new Map();
  inc.forEach((l) => byType.set(l.lineType, (byType.get(l.lineType) ?? new Decimal2(0)).plus(l.taxable)));
  const taxGroups = /* @__PURE__ */ new Map();
  inc.forEach((l) => {
    const k = new Decimal2(l.taxPercent ?? 0).toFixed(2);
    const g = taxGroups.get(k) ?? { taxable: new Decimal2(0), tax: new Decimal2(0) };
    taxGroups.set(k, { taxable: g.taxable.plus(l.taxable), tax: g.tax.plus(l.taxAmount) });
  });
  const lineDiscounts = sum(inc, (l) => l.discountAmount).minus(overall);
  const gross = sum(inc, (l) => l.gross);
  const maxDiscount = inc.reduce((m, l) => Decimal2.max(m, new Decimal2(l.discountPercent ?? 0)), new Decimal2(0));
  const effectiveDiscount = gross.isZero() ? new Decimal2(0) : gross.minus(taxable).div(gross).times(100);
  return {
    lines: out,
    totals: {
      gross: gross.toFixed(2),
      lineDiscounts: lineDiscounts.toFixed(2),
      overallDiscount: overall.toFixed(2),
      taxable: taxable.toFixed(2),
      tax: tax.toFixed(2),
      grandTotal: taxable.plus(tax).toFixed(2),
      optionalTotal: sum(out.filter((l) => l.isOptional), (l) => l.total).toFixed(2),
      cost: cost?.toFixed(2) ?? null,
      marginPercent: cost != null && !taxable.isZero() ? taxable.minus(cost).div(taxable).times(100).toFixed(2) : null,
      byType: [...byType.entries()].map(([lineType, v]) => ({ lineType, taxable: v.toFixed(2) })),
      taxBreakup: [...taxGroups.entries()].map(([taxPercent, g]) => ({ taxPercent, taxable: g.taxable.toFixed(2), tax: g.tax.toFixed(2) })),
      maxDiscountPercent: Decimal2.max(maxDiscount, effectiveDiscount).toDecimalPlaces(2).toFixed(2),
      overrides: out.filter((l) => l.isOverride).length
    }
  };
}
function pricingGuardrails(lines, totals, opts) {
  const w = [];
  const included = lines.filter((l) => !l.isOptional);
  if (totals.marginPercent != null) {
    const m = Number(totals.marginPercent);
    if (m < 0) w.push({ code: "NEGATIVE_MARGIN", severity: "critical", message: `Margin is negative (${m.toFixed(1)}%). The offer is below cost.` });
    else if (m < opts.minMarginPercent) w.push({ code: "LOW_MARGIN", severity: "warning", message: `Margin ${m.toFixed(1)}% is below the ${opts.minMarginPercent}% policy.` });
  } else if (included.length) {
    w.push({ code: "MISSING_COST", severity: "info", message: "Some lines have no cost, so margin cannot be checked." });
  }
  if (Number(totals.maxDiscountPercent) > opts.maxDiscountPercent) {
    w.push({ code: "HIGH_DISCOUNT", severity: "warning", message: `Discount of ${Number(totals.maxDiscountPercent).toFixed(1)}% is above the ${opts.maxDiscountPercent}% limit.` });
  }
  if (opts.division === "SOLAR" && included.length && !included.some((l) => l.lineType === "STRUCTURE")) {
    w.push({ code: "MISSING_STRUCTURE", severity: "warning", message: "No structure line. Check whether mounting structure is included or excluded on purpose." });
  }
  const noTax = included.filter((l) => !l.taxPercent);
  if (noTax.length) w.push({ code: "MISSING_TAX", severity: "warning", message: `${noTax.length} line(s) have no GST. Confirm they are exempt.` });
  if (totals.overrides) w.push({ code: "PRICE_OVERRIDE", severity: "info", message: `${totals.overrides} line(s) differ from the price list.` });
  const zero = included.filter((l) => Number(l.rate) === 0);
  if (zero.length) w.push({ code: "ZERO_RATE", severity: "warning", message: `${zero.length} line(s) are priced at \u20B90.` });
  return w;
}

// src/billing.ts
import Decimal3 from "decimal.js";
var TAX_MODES = ["CGST_SGST", "IGST", "ZERO_RATED", "EXEMPT"];
var TAX_MODE_LABELS = {
  CGST_SGST: "CGST + SGST (intra-state)",
  IGST: "IGST (inter-state)",
  ZERO_RATED: "Zero-rated (under LUT / bond)",
  EXEMPT: "Exempt / nil-rated"
};
var D = (v) => new Decimal3(v ?? 0);
var money2 = (v) => v.toDecimalPlaces(2, Decimal3.ROUND_HALF_UP);
function computeGst(lines, opts) {
  const nets = lines.map((l) => {
    const gross = money2(D(l.qty).times(l.rate));
    const disc = money2(gross.times(D(l.discountPercent)).div(100));
    return { gross, disc, net: gross.minus(disc) };
  });
  const netSum = nets.reduce((s, n) => s.plus(n.net), new Decimal3(0));
  const overall = Decimal3.min(money2(D(opts.overallDiscount)), netSum);
  let allocated = new Decimal3(0);
  const out = lines.map((l, i) => {
    const { gross, disc, net } = nets[i];
    let share = new Decimal3(0);
    if (overall.gt(0) && netSum.gt(0)) {
      share = i === lines.length - 1 ? overall.minus(allocated) : money2(overall.times(net).div(netSum));
      allocated = allocated.plus(share);
    }
    const taxable2 = net.minus(share);
    const rate = D(l.gstRate);
    let cgstRate = new Decimal3(0);
    let igstRate = new Decimal3(0);
    if (opts.taxMode === "CGST_SGST") cgstRate = rate.div(2);
    else if (opts.taxMode === "IGST") igstRate = rate;
    const cgst2 = money2(taxable2.times(cgstRate).div(100));
    const igst2 = money2(taxable2.times(igstRate).div(100));
    return {
      gross: gross.toFixed(2),
      discountAmount: disc.plus(share).toFixed(2),
      taxableValue: taxable2.toFixed(2),
      cgstRate: cgstRate.toFixed(2),
      cgstAmount: cgst2.toFixed(2),
      sgstRate: cgstRate.toFixed(2),
      sgstAmount: cgst2.toFixed(2),
      igstRate: igstRate.toFixed(2),
      igstAmount: igst2.toFixed(2),
      total: taxable2.plus(cgst2).plus(cgst2).plus(igst2).toFixed(2)
    };
  });
  const sum = (f) => out.reduce((s, l) => s.plus(f(l)), new Decimal3(0));
  const taxable = sum((l) => l.taxableValue);
  const cgst = sum((l) => l.cgstAmount);
  const sgst = sum((l) => l.sgstAmount);
  const igst = sum((l) => l.igstAmount);
  const beforeRound = taxable.plus(cgst).plus(sgst).plus(igst);
  const grand = opts.roundOff ? beforeRound.toDecimalPlaces(0, Decimal3.ROUND_HALF_UP) : beforeRound;
  const groups = /* @__PURE__ */ new Map();
  lines.forEach((l, i) => {
    const key = `${l.hsnSac ?? ""}|${D(l.gstRate).toFixed(2)}`;
    const g = groups.get(key) ?? { hsnSac: l.hsnSac ?? "", gstRate: D(l.gstRate).toFixed(2), taxableValue: new Decimal3(0), cgst: new Decimal3(0), sgst: new Decimal3(0), igst: new Decimal3(0) };
    g.taxableValue = g.taxableValue.plus(out[i].taxableValue);
    g.cgst = g.cgst.plus(out[i].cgstAmount);
    g.sgst = g.sgst.plus(out[i].sgstAmount);
    g.igst = g.igst.plus(out[i].igstAmount);
    groups.set(key, g);
  });
  return {
    lines: out,
    totals: {
      gross: sum((l) => l.gross).toFixed(2),
      lineDiscounts: nets.reduce((s, n) => s.plus(n.disc), new Decimal3(0)).toFixed(2),
      overallDiscount: overall.toFixed(2),
      taxableValue: taxable.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
      totalTax: cgst.plus(sgst).plus(igst).toFixed(2),
      roundOff: grand.minus(beforeRound).toFixed(2),
      grandTotal: grand.toFixed(2),
      hsnSummary: [...groups.values()].map((g) => ({
        hsnSac: g.hsnSac,
        gstRate: g.gstRate,
        taxableValue: g.taxableValue.toFixed(2),
        cgst: g.cgst.toFixed(2),
        sgst: g.sgst.toFixed(2),
        igst: g.igst.toFixed(2)
      }))
    }
  };
}
var gstStateCode = (stateCode2) => INDIAN_STATES.find((s) => s.code === stateCode2)?.gstCode ?? null;
var stateLabel = (stateCode2) => {
  const s = INDIAN_STATES.find((x) => x.code === stateCode2);
  return s ? `${s.name} (${s.gstCode})` : stateCode2 ?? "";
};
var AGEING_BUCKETS = [
  { key: "current", label: "Not due", min: -Infinity, max: -1 },
  { key: "d0_30", label: "0\u201330 days", min: 0, max: 30 },
  { key: "d31_60", label: "31\u201360 days", min: 31, max: 60 },
  { key: "d61_90", label: "61\u201390 days", min: 61, max: 90 },
  { key: "d90_plus", label: "90+ days", min: 91, max: Infinity }
];
function ageingBucket(daysPastDue) {
  return AGEING_BUCKETS.find((b) => daysPastDue >= b.min && daysPastDue <= b.max).key;
}

// src/schemas/billing.ts
import { z as z9 } from "zod";
var divisionEnum6 = z9.enum([DIVISIONS.SOLAR, DIVISIONS.TELECOM]);
var stateCode = z9.string().refine((v) => INDIAN_STATES.some((s) => s.code === v), "Choose a state");
var uuidOpt = z9.string().uuid().nullable().optional();
var SALES_DOC_TYPES = ["QUOTATION", "PROFORMA", "TAX_INVOICE", "CREDIT_NOTE", "DEBIT_NOTE"];
var SALES_DOC_TYPE_LABELS = {
  QUOTATION: "Quotation",
  PROFORMA: "Proforma invoice",
  TAX_INVOICE: "Tax invoice",
  CREDIT_NOTE: "Credit note",
  DEBIT_NOTE: "Debit note"
};
var SALES_DOC_TITLES = {
  QUOTATION: "QUOTATION",
  PROFORMA: "PROFORMA INVOICE \u2014 NOT A TAX INVOICE",
  TAX_INVOICE: "TAX INVOICE",
  CREDIT_NOTE: "CREDIT NOTE",
  DEBIT_NOTE: "DEBIT NOTE"
};
var SALES_DOC_PATHS = {
  QUOTATION: "quotations",
  PROFORMA: "proformas",
  TAX_INVOICE: "invoices",
  CREDIT_NOTE: "credit-notes",
  DEBIT_NOTE: "debit-notes"
};
var SALES_DOC_STATUSES = ["DRAFT", "PENDING_APPROVAL", "APPROVED", "SENT", "ACCEPTED", "REJECTED", "EXPIRED", "ISSUED", "POSTED", "CANCELLED"];
var SALES_DOC_STATUS_LABELS = {
  DRAFT: "Draft",
  PENDING_APPROVAL: "Pending approval",
  APPROVED: "Approved",
  SENT: "Sent",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  EXPIRED: "Expired",
  ISSUED: "Issued",
  POSTED: "Posted",
  CANCELLED: "Cancelled"
};
var SUPPLY_TYPES = ["B2B", "B2C", "SEZ_WITH_PAYMENT", "SEZ_WITHOUT_PAYMENT", "EXPORT_WITH_PAYMENT", "EXPORT_WITHOUT_PAYMENT", "DEEMED_EXPORT"];
var SUPPLY_TYPE_LABELS = {
  B2B: "Registered business (B2B)",
  B2C: "Unregistered / consumer (B2C)",
  SEZ_WITH_PAYMENT: "SEZ \u2014 with payment of tax",
  SEZ_WITHOUT_PAYMENT: "SEZ \u2014 without payment (LUT)",
  EXPORT_WITH_PAYMENT: "Export \u2014 with payment of tax",
  EXPORT_WITHOUT_PAYMENT: "Export \u2014 without payment (LUT)",
  DEEMED_EXPORT: "Deemed export"
};
var PAYMENT_MODES = ["CASH", "UPI", "NEFT", "RTGS", "IMPS", "CHEQUE", "DD", "CARD", "TDS", "OTHER"];
var PAYMENT_MODE_LABELS = {
  CASH: "Cash",
  UPI: "UPI",
  NEFT: "NEFT",
  RTGS: "RTGS",
  IMPS: "IMPS",
  CHEQUE: "Cheque",
  DD: "Demand draft",
  CARD: "Card",
  TDS: "TDS deducted by customer (Form 16A)",
  OTHER: "Other"
};
var billingLineSchema = z9.object({
  itemId: uuidOpt,
  description: z9.string().trim().min(1, "Describe the line").max(500),
  hsnSac: z9.string().trim().regex(/^\d{4,8}$/, "HSN/SAC is 4 to 8 digits").nullable().optional().or(z9.literal("").transform(() => null)),
  qty: z9.coerce.number().positive("Quantity must be more than zero").max(1e7),
  uom: z9.string().trim().min(1).max(10),
  rate: z9.coerce.number().min(0).max(1e9),
  discountPercent: z9.coerce.number().min(0).max(100).default(0),
  gstRate: z9.coerce.number().min(0).max(100),
  /** Credit/debit notes: the invoice line being adjusted. */
  sourceLineId: uuidOpt
});
var billingMilestoneSchema = z9.object({
  label: z9.string().trim().min(2).max(200),
  percent: z9.coerce.number().min(0).max(100),
  trigger: optionalString(200)
});
var docBase = z9.object({
  customerId: z9.string().uuid({ message: "Choose a customer" }),
  projectId: uuidOpt,
  siteId: uuidOpt,
  division: divisionEnum6.default("SOLAR"),
  docDate: z9.coerce.date(),
  placeOfSupplyState: stateCode,
  supplyType: z9.enum(SUPPLY_TYPES).default("B2B"),
  reverseCharge: z9.boolean().default(false),
  billingAddressId: uuidOpt,
  shippingAddressId: uuidOpt,
  lines: z9.array(billingLineSchema).min(1, "Add at least one line").max(500),
  overallDiscount: z9.coerce.number().min(0).default(0),
  notes: optionalString(2e3),
  terms: optionalString(5e3)
});
var milestonesSum = (v) => !v.paymentMilestones?.length || Math.abs(v.paymentMilestones.reduce((s, m) => s + m.percent, 0) - 100) < 0.01;
var quotationSchema = docBase.extend({
  validUntil: z9.coerce.date(),
  paymentMilestones: z9.array(billingMilestoneSchema).max(20).default([]),
  proposalId: uuidOpt
}).refine(milestonesSum, { path: ["paymentMilestones"], message: "Payment milestones must add up to 100%" }).refine((v) => v.validUntil >= v.docDate, { path: ["validUntil"], message: "Validity must be on or after the quotation date" });
var proformaSchema = docBase.extend({
  dueDate: z9.coerce.date().nullable().optional(),
  paymentMilestones: z9.array(billingMilestoneSchema).max(20).default([]),
  customerPoNumber: optionalString(60),
  customerPoDate: z9.coerce.date().nullable().optional(),
  sourceDocId: uuidOpt
}).refine(milestonesSum, { path: ["paymentMilestones"], message: "Payment milestones must add up to 100%" });
var taxInvoiceSchema = docBase.extend({
  paymentTermsDays: z9.coerce.number().int().min(0).max(365).default(15),
  customerPoNumber: optionalString(60),
  customerPoDate: z9.coerce.date().nullable().optional(),
  sourceDocId: uuidOpt
});
var NOTE_REASONS = ["SALES_RETURN", "POST_SALE_DISCOUNT", "DEFICIENCY_IN_SERVICE", "CORRECTION_IN_INVOICE", "CHANGE_IN_POS", "FINALIZATION_OF_PROVISIONAL", "OTHERS"];
var NOTE_REASON_LABELS = {
  SALES_RETURN: "Sales return",
  POST_SALE_DISCOUNT: "Post-sale discount",
  DEFICIENCY_IN_SERVICE: "Deficiency in service",
  CORRECTION_IN_INVOICE: "Correction in invoice",
  CHANGE_IN_POS: "Change in place of supply",
  FINALIZATION_OF_PROVISIONAL: "Finalisation of provisional assessment",
  OTHERS: "Others"
};
var noteSchema = z9.object({
  againstInvoiceId: z9.string().uuid({ message: "Choose the invoice" }),
  docDate: z9.coerce.date(),
  reasonCode: z9.enum(NOTE_REASONS),
  reason: z9.string().trim().min(3, "Explain the reason").max(1e3),
  lines: z9.array(billingLineSchema).min(1, "Add at least one line").max(500),
  notes: optionalString(2e3)
});
var salesDocListQuerySchema = listQuerySchema.extend({
  status: z9.enum([...SALES_DOC_STATUSES, "OPEN", "ALL"]).default("ALL"),
  division: divisionEnum6.optional(),
  customerId: z9.string().uuid().optional(),
  projectId: z9.string().uuid().optional(),
  from: z9.coerce.date().optional(),
  to: z9.coerce.date().optional(),
  outstanding: z9.enum(["true", "false"]).optional()
});
var docDecisionSchema = z9.object({ comment: optionalString(1e3) });
var docRejectSchema = z9.object({ comment: z9.string().trim().min(3, "Give a reason").max(1e3) });
var docCancelSchema = z9.object({ reason: z9.string().trim().min(3, "Give a reason").max(1e3) });
var quotationOutcomeSchema = z9.object({ outcome: z9.enum(["ACCEPTED", "REJECTED"]), comment: optionalString(1e3) }).refine((v) => v.outcome !== "REJECTED" || v.comment && v.comment.length >= 3, { path: ["comment"], message: "Say why it was rejected" });
var convertDocSchema = z9.object({ to: z9.enum(["PROFORMA", "TAX_INVOICE"]) });
var emailDocSchema = z9.object({
  to: z9.string().trim().email("Enter a valid email"),
  cc: z9.string().trim().email().nullable().optional().or(z9.literal("").transform(() => null)),
  message: optionalString(2e3)
});
var allocationInputSchema = z9.object({ documentId: z9.string().uuid(), amount: z9.coerce.number().positive("Amount must be more than zero") });
var receiptSchema = z9.object({
  customerId: z9.string().uuid({ message: "Choose a customer" }),
  projectId: uuidOpt,
  division: divisionEnum6.default("SOLAR"),
  receiptDate: z9.coerce.date(),
  mode: z9.enum(PAYMENT_MODES),
  reference: optionalString(80),
  bankName: optionalString(120),
  amount: z9.coerce.number().positive("Amount must be more than zero").max(1e10),
  notes: optionalString(1e3),
  allocations: z9.array(allocationInputSchema).max(100).default([])
}).refine((v) => v.mode === "CASH" || v.reference && v.reference.length >= 3, { path: ["reference"], message: "Enter the UTR / cheque / transaction reference" }).refine((v) => v.allocations.reduce((s, a) => s + a.amount, 0) <= v.amount + 1e-3, { path: ["allocations"], message: "Allocations cannot exceed the amount received" });
var allocateSchema = z9.object({ allocations: z9.array(allocationInputSchema).min(1).max(100) });
var reverseReceiptSchema = z9.object({ reason: z9.string().trim().min(3, "Give a reason").max(1e3) });
var receiptListQuerySchema = listQuerySchema.extend({
  status: z9.enum(["ACTIVE", "REVERSED", "ALL"]).default("ALL"),
  division: divisionEnum6.optional(),
  customerId: z9.string().uuid().optional(),
  unallocated: z9.enum(["true", "false"]).optional(),
  from: z9.coerce.date().optional(),
  to: z9.coerce.date().optional()
});
var taxRuleSchema = z9.object({
  name: z9.string().trim().min(3).max(120),
  supplyType: z9.enum(SUPPLY_TYPES),
  /** null = applies to both intra-state and inter-state supplies. */
  interState: z9.boolean().nullable(),
  taxMode: z9.enum(TAX_MODES),
  reverseCharge: z9.boolean().default(false),
  effectiveFrom: z9.coerce.date(),
  effectiveTo: z9.coerce.date().nullable().optional(),
  notes: optionalString(1e3),
  isActive: z9.boolean().default(true)
}).refine((v) => !v.effectiveTo || v.effectiveTo >= v.effectiveFrom, { path: ["effectiveTo"], message: "End date must be after the start date" });
var billingSettingsSchema = z9.object({
  /** Round the grand total to the nearest rupee and show the difference as round-off. */
  roundOffTotal: z9.boolean().default(true),
  defaultPaymentTermsDays: z9.coerce.number().int().min(0).max(365).default(15),
  quotationValidityDays: z9.coerce.number().int().min(1).max(365).default(30),
  /** Printed on tax invoices and proformas. */
  invoiceTerms: z9.string().trim().max(5e3).default(""),
  quotationTerms: z9.string().trim().max(5e3).default(""),
  showBankDetails: z9.boolean().default(true),
  showUpiQr: z9.boolean().default(true),
  /** Text shown under the signature box, e.g. "Authorised signatory". */
  signatoryLabel: z9.string().trim().max(120).default("Authorised signatory")
});
var statementQuerySchema = z9.object({
  from: z9.coerce.date().optional(),
  to: z9.coerce.date().optional()
});

// src/schemas/inventory.ts
import { z as z10 } from "zod";
var divisionEnum7 = z10.enum([DIVISIONS.SOLAR, DIVISIONS.TELECOM]);
var uuidOpt2 = z10.string().uuid().nullable().optional();
var LOCATION_TYPES = ["WAREHOUSE", "SITE", "TRANSIT", "SCRAP"];
var LOCATION_TYPE_LABELS = { WAREHOUSE: "Warehouse", SITE: "Site store", TRANSIT: "In transit", SCRAP: "Scrap yard" };
var STOCK_DOC_TYPES = ["OPENING", "TRANSFER", "SITE_ISSUE", "SITE_RETURN", "DAMAGE", "ADJUSTMENT"];
var STOCK_DOC_TYPE_LABELS = {
  OPENING: "Opening stock",
  TRANSFER: "Stock transfer",
  SITE_ISSUE: "Issue to site",
  SITE_RETURN: "Return from site",
  DAMAGE: "Damage write-off",
  ADJUSTMENT: "Stock adjustment"
};
var STOCK_DOC_PATHS = {
  OPENING: "opening",
  TRANSFER: "transfers",
  SITE_ISSUE: "issues",
  SITE_RETURN: "returns",
  DAMAGE: "damage",
  ADJUSTMENT: "adjustments"
};
var STOCK_DOC_SERIES = {
  OPENING: "STOCK_ADJUSTMENT",
  TRANSFER: "STOCK_TRANSFER",
  SITE_ISSUE: "MATERIAL_ISSUE",
  SITE_RETURN: "MATERIAL_RETURN",
  DAMAGE: "STOCK_ADJUSTMENT",
  ADJUSTMENT: "STOCK_ADJUSTMENT"
};
var STOCK_DOC_STATUSES = ["DRAFT", "PENDING_APPROVAL", "APPROVED", "POSTED", "CANCELLED"];
var STOCK_DOC_STATUS_LABELS = {
  DRAFT: "Draft",
  PENDING_APPROVAL: "Pending approval",
  APPROVED: "Approved",
  POSTED: "Posted",
  CANCELLED: "Cancelled"
};
var MOVEMENT_TYPE_LABELS = {
  OPENING: "Opening",
  RECEIPT: "Goods receipt",
  TRANSFER_OUT: "Transfer out",
  TRANSFER_IN: "Transfer in",
  SITE_ISSUE: "Issued to site",
  SITE_RETURN: "Returned from site",
  DAMAGE: "Damaged",
  ADJUSTMENT_IN: "Adjustment (+)",
  ADJUSTMENT_OUT: "Adjustment (\u2212)"
};
var PROCUREMENT_STATUSES = ["DRAFT", "PENDING_APPROVAL", "APPROVED", "ORDERED", "SENT", "PARTIALLY_RECEIVED", "RECEIVED", "CLOSED", "REJECTED", "CANCELLED"];
var PROCUREMENT_STATUS_LABELS = {
  DRAFT: "Draft",
  PENDING_APPROVAL: "Pending approval",
  APPROVED: "Approved",
  ORDERED: "Ordered",
  SENT: "Sent to supplier",
  PARTIALLY_RECEIVED: "Partly received",
  RECEIVED: "Received",
  CLOSED: "Closed",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled"
};
var locationSchema = z10.object({
  code: z10.string().trim().toUpperCase().min(2).max(30).regex(/^[A-Z0-9/_-]+$/, "Use letters, digits, / _ -"),
  name: z10.string().trim().min(2).max(150),
  type: z10.enum(LOCATION_TYPES),
  division: divisionEnum7.nullable().optional(),
  siteId: uuidOpt2,
  addressLine1: optionalString(200),
  city: optionalString(80),
  stateCode: z10.string().length(2).nullable().optional(),
  isActive: z10.boolean().default(true)
}).refine((v) => v.type === "SITE" === !!v.siteId, { path: ["siteId"], message: "A site store must be linked to one site (and only site stores can be)" });
var stockDocLineSchema = z10.object({
  itemId: z10.string().uuid({ message: "Choose an item" }),
  qty: z10.coerce.number().refine((n) => n !== 0, "Quantity cannot be zero").refine((n) => Math.abs(n) <= 1e7, "Quantity is too large"),
  unitCost: z10.coerce.number().min(0).nullable().optional(),
  batchId: uuidOpt2,
  serialIds: z10.array(z10.string().uuid()).max(5e3).default([]),
  /** New serial numbers (opening stock / positive adjustment of serialised items). */
  newSerials: z10.array(z10.string().trim().min(1).max(80)).max(5e3).default([]),
  batchNo: optionalString(60),
  variant: optionalString(60),
  measurement: optionalString(120),
  remarks: optionalString(500)
});
var stockDocSchema = z10.object({
  docType: z10.enum(STOCK_DOC_TYPES),
  division: divisionEnum7.default("SOLAR"),
  fromLocationId: uuidOpt2,
  toLocationId: uuidOpt2,
  projectId: uuidOpt2,
  siteId: uuidOpt2,
  docDate: z10.coerce.date(),
  reason: optionalString(1e3),
  notes: optionalString(2e3),
  lines: z10.array(stockDocLineSchema).min(1, "Add at least one line").max(500)
}).superRefine((v, ctx) => {
  const need = (field, message) => {
    if (!v[field]) ctx.addIssue({ code: z10.ZodIssueCode.custom, path: [field], message });
  };
  switch (v.docType) {
    case "TRANSFER":
      need("fromLocationId", "Choose where the stock comes from");
      need("toLocationId", "Choose where it goes");
      if (v.fromLocationId && v.fromLocationId === v.toLocationId) ctx.addIssue({ code: z10.ZodIssueCode.custom, path: ["toLocationId"], message: "Choose a different location" });
      break;
    case "SITE_ISSUE":
      need("fromLocationId", "Choose the store issuing the material");
      need("projectId", "Choose the project");
      break;
    case "SITE_RETURN":
      need("toLocationId", "Choose the store receiving the material");
      need("projectId", "Choose the project");
      break;
    case "DAMAGE":
      need("fromLocationId", "Choose the location");
      need("reason", "Say what happened");
      break;
    case "ADJUSTMENT":
      need("fromLocationId", "Choose the location");
      need("reason", "Give the reason for the adjustment");
      break;
    case "OPENING":
      need("toLocationId", "Choose the location");
      v.lines.forEach((l, i) => {
        if (l.unitCost == null) ctx.addIssue({ code: z10.ZodIssueCode.custom, path: ["lines", i, "unitCost"], message: "Enter the unit cost" });
      });
      break;
  }
  if (v.docType !== "ADJUSTMENT") {
    v.lines.forEach((l, i) => {
      if (l.qty < 0) ctx.addIssue({ code: z10.ZodIssueCode.custom, path: ["lines", i, "qty"], message: "Quantity must be positive" });
    });
  }
});
var stockDocListQuerySchema = listQuerySchema.extend({
  docType: z10.enum(STOCK_DOC_TYPES).optional(),
  status: z10.enum([...STOCK_DOC_STATUSES, "ALL"]).default("ALL"),
  locationId: z10.string().uuid().optional(),
  projectId: z10.string().uuid().optional()
});
var stockQuerySchema = listQuerySchema.extend({
  locationId: z10.string().uuid().optional(),
  categoryId: z10.string().uuid().optional(),
  belowReorder: z10.enum(["true", "false"]).optional(),
  includeZero: z10.enum(["true", "false"]).optional()
});
var ledgerQuerySchema = listQuerySchema.extend({
  itemId: z10.string().uuid().optional(),
  locationId: z10.string().uuid().optional(),
  projectId: z10.string().uuid().optional(),
  from: z10.coerce.date().optional(),
  to: z10.coerce.date().optional()
});
var reservationSchema = z10.object({
  itemId: z10.string().uuid(),
  locationId: z10.string().uuid(),
  projectId: z10.string().uuid(),
  siteId: uuidOpt2,
  qty: z10.coerce.number().positive(),
  notes: optionalString(500)
});
var bomLineSchema = z10.object({
  siteId: uuidOpt2,
  itemId: z10.string().uuid(),
  plannedQty: z10.coerce.number().positive(),
  variant: optionalString(60),
  notes: optionalString(500)
});
var bomReplaceSchema = z10.object({ lines: z10.array(bomLineSchema).max(1e3) });
var bomFromDocSchema = z10.object({ source: z10.literal("QUOTATION").default("QUOTATION"), sourceId: z10.string().uuid(), siteId: uuidOpt2 });
var prLineSchema = z10.object({
  itemId: z10.string().uuid({ message: "Choose an item" }),
  qty: z10.coerce.number().positive("Quantity must be more than zero"),
  estimatedRate: z10.coerce.number().min(0).nullable().optional(),
  variant: optionalString(60),
  measurement: optionalString(120),
  remarks: optionalString(500)
});
var purchaseRequestSchema = z10.object({
  division: divisionEnum7.default("SOLAR"),
  projectId: uuidOpt2,
  siteId: uuidOpt2,
  requiredBy: z10.coerce.date().nullable().optional(),
  notes: optionalString(2e3),
  lines: z10.array(prLineSchema).min(1, "Add at least one line").max(300)
});
var poLineSchema = z10.object({
  itemId: z10.string().uuid({ message: "Choose an item" }),
  description: z10.string().trim().min(1).max(500),
  hsnSac: z10.string().trim().regex(/^\d{4,8}$/, "HSN/SAC is 4 to 8 digits").nullable().optional().or(z10.literal("").transform(() => null)),
  qty: z10.coerce.number().positive("Quantity must be more than zero"),
  uom: z10.string().trim().min(1).max(10),
  rate: z10.coerce.number().min(0),
  discountPercent: z10.coerce.number().min(0).max(100).default(0),
  gstRate: z10.coerce.number().min(0).max(100),
  variant: optionalString(60),
  measurement: optionalString(120)
});
var purchaseOrderSchema = z10.object({
  division: divisionEnum7.default("SOLAR"),
  supplierId: z10.string().uuid({ message: "Choose a supplier" }),
  requestId: uuidOpt2,
  projectId: uuidOpt2,
  deliveryLocationId: z10.string().uuid({ message: "Choose where goods are delivered" }),
  orderDate: z10.coerce.date(),
  expectedDate: z10.coerce.date().nullable().optional(),
  paymentTerms: optionalString(300),
  notes: optionalString(2e3),
  terms: optionalString(5e3),
  lines: z10.array(poLineSchema).min(1, "Add at least one line").max(300)
});
var grnLineSchema = z10.object({
  orderLineId: uuidOpt2,
  itemId: z10.string().uuid(),
  qtyReceived: z10.coerce.number().positive("Enter the quantity received"),
  qtyAccepted: z10.coerce.number().min(0),
  unitCost: z10.coerce.number().min(0),
  batchNo: optionalString(60),
  mfgDate: z10.coerce.date().nullable().optional(),
  expiryDate: z10.coerce.date().nullable().optional(),
  serials: z10.array(z10.string().trim().min(1).max(80)).max(5e3).default([]),
  variant: optionalString(60),
  remarks: optionalString(500)
}).refine((l) => l.qtyAccepted <= l.qtyReceived, { path: ["qtyAccepted"], message: "Accepted cannot exceed received" });
var goodsReceiptSchema = z10.object({
  orderId: uuidOpt2,
  supplierId: z10.string().uuid({ message: "Choose a supplier" }),
  locationId: z10.string().uuid({ message: "Choose the receiving location" }),
  receiptDate: z10.coerce.date(),
  supplierInvoiceNo: optionalString(60),
  supplierInvoiceDate: z10.coerce.date().nullable().optional(),
  supplierInvoiceAmt: z10.coerce.number().min(0).nullable().optional(),
  vehicleNo: optionalString(20),
  notes: optionalString(2e3),
  lines: z10.array(grnLineSchema).min(1, "Add at least one line").max(300)
});
var procurementListQuerySchema = listQuerySchema.extend({
  status: z10.enum([...PROCUREMENT_STATUSES, "OPEN", "ALL"]).default("ALL"),
  supplierId: z10.string().uuid().optional(),
  projectId: z10.string().uuid().optional(),
  overdue: z10.enum(["true", "false"]).optional()
});
var grnListQuerySchema = listQuerySchema.extend({
  status: z10.enum(["DRAFT", "POSTED", "CANCELLED", "ALL"]).default("ALL"),
  supplierId: z10.string().uuid().optional(),
  orderId: z10.string().uuid().optional()
});
var complianceRuleSchema = z10.object({
  code: z10.string().trim().toUpperCase().min(2).max(20),
  name: z10.string().trim().min(3).max(150),
  categoryId: z10.string().uuid(),
  effectiveFrom: z10.coerce.date(),
  effectiveTo: z10.coerce.date().nullable().optional(),
  sourceUrl: z10.string().trim().url().max(500).nullable().optional().or(z10.literal("").transform(() => null)),
  notes: optionalString(1e3),
  isActive: z10.boolean().default(true)
}).refine((v) => !v.effectiveTo || v.effectiveTo >= v.effectiveFrom, { path: ["effectiveTo"], message: "End date must be after the start date" });
var itemComplianceDocSchema = z10.object({
  ruleId: z10.string().uuid(),
  certificateNo: z10.string().trim().min(2).max(80),
  validFrom: z10.coerce.date(),
  validTo: z10.coerce.date().nullable().optional(),
  fileId: uuidOpt2,
  notes: optionalString(500)
}).refine((v) => !v.validTo || v.validTo >= v.validFrom, { path: ["validTo"], message: "End date must be after the start date" });
var inventorySettingsSchema = z10.object({
  /** Refuse movements that would take a location below zero. */
  allowNegativeStock: z10.boolean().default(false),
  adjustmentNeedsApproval: z10.boolean().default(true),
  damageNeedsApproval: z10.boolean().default(true),
  /** Warn (not block) when issuing more than the project's planned quantity. */
  warnOverIssue: z10.boolean().default(true),
  /** Alert on material issued beyond plan and not returned after this many days. */
  unreturnedAlertDays: z10.coerce.number().int().min(1).max(365).default(30),
  /** Block purchase orders and site issues of items without a valid compliance certificate (otherwise warn). */
  blockNonCompliant: z10.boolean().default(false),
  /** Typical days from purchase request to stock in hand, used by the shortage forecast. */
  purchaseLeadTimeDays: z10.coerce.number().int().min(1).max(180).default(14),
  /** How far ahead the shortage forecast looks. */
  forecastHorizonDays: z10.coerce.number().int().min(7).max(180).default(30)
});

// src/schemas/execution.ts
import { z as z11 } from "zod";
var uuidOpt3 = z11.string().uuid().nullable().optional();
var numOpt = (max = 1e9) => z11.coerce.number().min(0).max(max).nullable().optional();
var intOpt = (max = 1e6) => z11.coerce.number().int().min(0).max(max).nullable().optional();
var dateOpt = z11.coerce.date().nullable().optional();
var ROOF_TYPES = ["RCC", "METAL_SHEET", "TILE", "ASBESTOS", "GROUND", "CARPORT", "OTHER"];
var ROOF_TYPE_LABELS = {
  RCC: "RCC (concrete)",
  METAL_SHEET: "Metal sheet",
  TILE: "Tiled",
  ASBESTOS: "Asbestos sheet",
  GROUND: "Ground mount",
  CARPORT: "Carport",
  OTHER: "Other"
};
var ROOF_CONDITIONS = ["GOOD", "FAIR", "POOR"];
var ROOF_CONDITION_LABELS = { GOOD: "Good", FAIR: "Fair \u2014 minor repairs", POOR: "Poor \u2014 repair before install" };
var LEG_HEIGHTS = ["6.5 ft", "8 ft"];
var SURVEY_MISSING_INFO = [
  "Latest electricity bill",
  "Consumer number",
  "Sanctioned load confirmation",
  "Roof access / owner permission",
  "Earthing location",
  "Inverter location",
  "Cable route",
  "Shadow analysis",
  "Structural stability confirmation"
];
var SURVEY_STATUSES = ["DRAFT", "SUBMITTED", "APPROVED"];
var SURVEY_STATUS_LABELS = { DRAFT: "Draft", SUBMITTED: "Submitted", APPROVED: "Approved" };
var DESIGN_STATUSES = ["DRAFT", "APPROVED", "SUPERSEDED"];
var DESIGN_STATUS_LABELS = { DRAFT: "Draft", APPROVED: "Approved", SUPERSEDED: "Superseded" };
var MILESTONE_STATUSES = ["PENDING", "IN_PROGRESS", "DONE", "BLOCKED", "SKIPPED"];
var MILESTONE_STATUS_LABELS = { PENDING: "Pending", IN_PROGRESS: "In progress", DONE: "Done", BLOCKED: "Blocked", SKIPPED: "Not needed" };
var DPR_STATUSES = ["DRAFT", "SUBMITTED", "SIGNED_OFF"];
var DPR_STATUS_LABELS = { DRAFT: "Draft", SUBMITTED: "Awaiting sign-off", SIGNED_OFF: "Signed off" };
var DEFECT_SEVERITIES = ["LOW", "MEDIUM", "HIGH"];
var DEFECT_STATUSES = ["OPEN", "RESOLVED"];
var CHECKLIST_KINDS = ["COMMISSIONING", "HANDOVER", "QUALITY"];
var CHECKLIST_KIND_LABELS = { COMMISSIONING: "Testing & commissioning", HANDOVER: "Handover", QUALITY: "Quality checklist" };
var CHECKLIST_KINDS_BY_DIVISION = { SOLAR: ["COMMISSIONING", "HANDOVER"], TELECOM: ["QUALITY"] };
var CHECKLIST_ITEM_TYPES = ["CHECK", "TEXT", "NUMBER"];
var TRACKER_KINDS = ["DISCOM", "SUBSIDY"];
var MILESTONE_SOURCES = ["PORTAL", "DISCOM_OFFICE", "CUSTOMER", "EMAIL", "PHONE", "SITE_VISIT", "OTHER"];
var MILESTONE_SOURCE_LABELS = {
  PORTAL: "National portal (checked)",
  DISCOM_OFFICE: "DISCOM office / letter",
  CUSTOMER: "Customer",
  EMAIL: "Email",
  PHONE: "Phone call",
  SITE_VISIT: "Site visit",
  OTHER: "Other"
};
var MILESTONE_OUTCOMES = ["DONE", "PENDING", "REJECTED"];
var MILESTONE_OUTCOME_LABELS = { DONE: "Completed", PENDING: "Pending / in progress", REJECTED: "Rejected / returned" };
var SUBSIDY_AMOUNT_STAGE = "AMOUNT_APPROVED";
var stageSchema = z11.object({
  key: z11.string().trim().toUpperCase().regex(/^[A-Z0-9_]{2,40}$/, "Use capital letters, digits and underscores"),
  label: z11.string().trim().min(2).max(120),
  evidenceRequired: z11.boolean().default(true)
});
var uniqueKeys = (stages) => new Set(stages.map((s) => s.key)).size === stages.length;
var executionSettingsSchema = z11.object({
  /** Milestones created when execution is planned for a site; offsets are days from the planned start. */
  milestoneTemplate: z11.array(z11.object({ name: z11.string().trim().min(2).max(120), offsetDays: z11.coerce.number().int().min(0).max(365).default(0) })).min(1).max(30).default([
    { name: "Material dispatch to site", offsetDays: 0 },
    { name: "Structure erection", offsetDays: 1 },
    { name: "Module mounting", offsetDays: 2 },
    { name: "Inverter, DBs and cabling", offsetDays: 3 },
    { name: "Earthing and lightning arrester", offsetDays: 3 },
    { name: "Testing and commissioning", offsetDays: 4 },
    { name: "Net meter installation", offsetDays: 15 },
    { name: "Handover to customer", offsetDays: 16 }
  ]),
  discomStages: z11.array(stageSchema).min(1).max(20).refine(uniqueKeys, "Stage keys must be unique").default([
    { key: "APPLICATION", label: "Net-metering application submitted", evidenceRequired: true },
    { key: "FEASIBILITY", label: "Technical feasibility approved", evidenceRequired: true },
    { key: "METER_PAYMENT", label: "Meter / registration fee paid", evidenceRequired: true },
    { key: "INSPECTION", label: "DISCOM inspection completed", evidenceRequired: true },
    { key: "NET_METER", label: "Net meter installed", evidenceRequired: true },
    { key: "CONNECTION", label: "Grid connection / synchronisation", evidenceRequired: true }
  ]),
  subsidyStages: z11.array(stageSchema).min(1).max(20).refine(uniqueKeys, "Stage keys must be unique").default([
    { key: "REGISTRATION", label: "Consumer registered on the national portal", evidenceRequired: true },
    { key: "APPLICATION", label: "Rooftop application submitted", evidenceRequired: true },
    { key: "FEASIBILITY", label: "Feasibility approved by DISCOM", evidenceRequired: true },
    { key: "VENDOR_SELECTED", label: "Vendor selected by consumer", evidenceRequired: true },
    { key: "INSTALLATION_SUBMITTED", label: "Installation details submitted", evidenceRequired: true },
    { key: "INSPECTION", label: "Inspection / commissioning certificate", evidenceRequired: true },
    { key: "BANK_DETAILS", label: "Bank details submitted for subsidy", evidenceRequired: true },
    { key: "DISBURSEMENT", label: "Subsidy released", evidenceRequired: true }
  ]),
  /** Official source the stage list was last checked against. */
  schemeSourceUrl: z11.string().trim().url().max(500).nullable().default("https://solarrooftop.pmsuryaghar.gov.in/"),
  schemeLastVerifiedOn: z11.coerce.date().nullable().default(null),
  /** Tracker entries not re-verified for this many days are flagged as stale. */
  staleVerificationDays: z11.coerce.number().int().min(1).max(365).default(15),
  /** Photos a daily report needs before it can be submitted. */
  dprMinPhotos: z11.coerce.number().int().min(0).max(20).default(1)
});
var measurementSchema = z11.object({ label: z11.string().trim().min(1).max(80), value: z11.coerce.number().min(0).max(1e6), unit: z11.string().trim().min(1).max(20) });
var surveySchema = z11.object({
  surveyDate: z11.coerce.date(),
  latitude: z11.coerce.number().min(-90).max(90).nullable().optional(),
  longitude: z11.coerce.number().min(-180).max(180).nullable().optional(),
  gpsAccuracyM: numOpt(1e5),
  roofType: z11.enum(ROOF_TYPES).nullable().optional(),
  roofCondition: z11.enum(ROOF_CONDITIONS).nullable().optional(),
  roofAgeYears: intOpt(200),
  floors: intOpt(200),
  buildingHeightM: numOpt(500),
  roofLengthM: numOpt(1e4),
  roofWidthM: numOpt(1e4),
  usableAreaSqm: numOpt(1e7),
  orientation: optionalString(30),
  tiltDeg: numOpt(90),
  shadingNotes: optionalString(1e3),
  structureNotes: optionalString(1e3),
  recommendedLegHeight: optionalString(20),
  recommendedKw: numOpt(1e5),
  phase: z11.enum(PHASES).nullable().optional(),
  sanctionedLoadKw: numOpt(1e5),
  discomId: uuidOpt3,
  consumerNumber: optionalString(40),
  meterLocation: optionalString(200),
  earthingAvailable: z11.boolean().nullable().optional(),
  inverterLocation: optionalString(200),
  acCableRunM: numOpt(1e5),
  dcCableRunM: numOpt(1e5),
  measurements: z11.array(measurementSchema).max(50).default([]),
  missingInfo: z11.array(z11.string().trim().min(1).max(120)).max(30).default([]),
  remarks: optionalString(2e3)
});
var designMaterialLineSchema = z11.object({
  itemId: uuidOpt3,
  description: z11.string().trim().min(1).max(300),
  qty: z11.coerce.number().positive("Quantity must be more than zero").max(1e7),
  unit: z11.string().trim().min(1).max(20)
});
var designSchema = z11.object({
  source: z11.enum(["MANUAL", "FILE_IMPORT"]).default("MANUAL"),
  reference: optionalString(80),
  designDate: z11.coerce.date(),
  dcCapacityKw: z11.coerce.number().positive("Enter the DC capacity").max(1e5),
  acCapacityKw: numOpt(1e5),
  moduleItemId: uuidOpt3,
  moduleCount: intOpt(1e6),
  inverterItemId: uuidOpt3,
  inverterCount: intOpt(1e4),
  estimatedYieldKwh: numOpt(1e10),
  performanceRatio: numOpt(100),
  tariffPerKwh: numOpt(1e3),
  annualEscalationPct: numOpt(100),
  systemCost: numOpt(1e11),
  paybackYears: numOpt(100),
  stringing: optionalString(4e3),
  materialSchedule: z11.array(designMaterialLineSchema).max(300).default([]),
  notes: optionalString(2e3)
});
var crewSchema = z11.object({
  code: z11.string().trim().toUpperCase().min(2).max(20),
  name: z11.string().trim().min(2).max(120),
  division: z11.enum(["SOLAR", "TELECOM"]),
  leaderId: uuidOpt3,
  phone: optionalString(20),
  isActive: z11.boolean().default(true),
  members: z11.array(z11.object({ name: z11.string().trim().min(2).max(120), role: optionalString(60), phone: optionalString(20), userId: uuidOpt3 })).max(50).default([])
});
var executionPlanSchema = z11.object({
  crewId: uuidOpt3,
  plannedStart: z11.coerce.date(),
  /** Replace existing pending milestones with the configured template. */
  useTemplate: z11.boolean().default(true)
});
var milestoneSchema = z11.object({
  name: z11.string().trim().min(2).max(120),
  plannedDate: dateOpt,
  actualDate: dateOpt,
  status: z11.enum(MILESTONE_STATUSES).default("PENDING"),
  ownerId: uuidOpt3,
  crewId: uuidOpt3,
  notes: optionalString(1e3)
});
var dprLineSchema = z11.object({
  milestoneId: uuidOpt3,
  /** Telecom: the work-order rate line this quantity was executed against (measured for billing). */
  woLineId: uuidOpt3,
  task: z11.string().trim().min(2).max(300),
  plannedQty: numOpt(1e7),
  actualQty: numOpt(1e7),
  unit: optionalString(20),
  remarks: optionalString(500)
});
var dprSchema = z11.object({
  reportDate: z11.coerce.date(),
  crewId: uuidOpt3,
  headcount: intOpt(1e3),
  weather: optionalString(40),
  workSummary: z11.string().trim().min(5, "Describe the work done").max(4e3),
  blockers: optionalString(2e3),
  nextDayPlan: optionalString(2e3),
  legHeight: optionalString(20),
  structuresErected: z11.coerce.number().int().min(0).max(1e5).default(0),
  panelsInstalled: z11.coerce.number().int().min(0).max(1e5).default(0),
  invertersInstalled: z11.coerce.number().int().min(0).max(1e4).default(0),
  acdbInstalled: z11.coerce.number().int().min(0).max(1e4).default(0),
  dcdbInstalled: z11.coerce.number().int().min(0).max(1e4).default(0),
  acCableM: z11.coerce.number().min(0).max(1e6).default(0),
  dcCableM: z11.coerce.number().min(0).max(1e6).default(0),
  earthingPits: z11.coerce.number().int().min(0).max(1e3).default(0),
  lines: z11.array(dprLineSchema).max(50).default([]),
  /** New defects found today. */
  defects: z11.array(z11.object({ title: z11.string().trim().min(3).max(200), description: optionalString(2e3), severity: z11.enum(DEFECT_SEVERITIES).default("MEDIUM") })).max(30).default([])
});
var dprListQuerySchema = listQuerySchema.extend({
  status: z11.enum([...DPR_STATUSES, "ALL"]).default("ALL"),
  siteId: z11.string().uuid().optional(),
  projectId: z11.string().uuid().optional(),
  from: z11.coerce.date().optional(),
  to: z11.coerce.date().optional(),
  blockers: z11.enum(["true", "false"]).optional()
});
var defectSchema = z11.object({
  title: z11.string().trim().min(3).max(200),
  description: optionalString(2e3),
  severity: z11.enum(DEFECT_SEVERITIES).default("MEDIUM")
});
var checklistTemplateItemSchema = z11.object({
  key: z11.string().trim().regex(/^[a-z0-9_]{2,40}$/, "Use lowercase letters, digits and underscores"),
  label: z11.string().trim().min(2).max(200),
  type: z11.enum(CHECKLIST_ITEM_TYPES).default("CHECK"),
  required: z11.boolean().default(true),
  evidenceRequired: z11.boolean().default(false),
  hint: optionalString(300)
});
var checklistTemplateSchema = z11.object({
  kind: z11.enum(CHECKLIST_KINDS),
  name: z11.string().trim().min(3).max(120),
  division: z11.enum(["SOLAR", "TELECOM"]).nullable().optional(),
  isActive: z11.boolean().default(true),
  items: z11.array(checklistTemplateItemSchema).min(1, "Add at least one item").max(100).refine((items) => new Set(items.map((i) => i.key)).size === items.length, "Item keys must be unique")
});
var checklistItemUpdateSchema = z11.object({
  checked: z11.boolean(),
  value: optionalString(500),
  remarks: optionalString(500),
  evidenceFileId: uuidOpt3
});
var siteAssetSchema = z11.object({
  itemId: z11.string().uuid({ message: "Choose an item" }),
  serialNo: optionalString(80),
  quantity: z11.coerce.number().positive().max(1e6).default(1),
  installedOn: dateOpt,
  warrantyMonths: intOpt(600),
  complianceDocId: uuidOpt3,
  datasheetFileId: uuidOpt3,
  warrantyFileId: uuidOpt3,
  notes: optionalString(500)
});
var discomApplicationSchema = z11.object({
  discomId: uuidOpt3,
  consumerNumber: optionalString(40),
  sanctionedLoadKw: numOpt(1e5),
  applicationNo: optionalString(60),
  appliedOn: dateOpt,
  netMeterNumber: optionalString(40),
  ownerId: uuidOpt3,
  notes: optionalString(1e3)
});
var subsidyApplicationSchema = z11.object({
  scheme: z11.string().trim().min(2).max(60).default("PM Surya Ghar: Muft Bijli Yojana"),
  applicationRef: optionalString(60),
  registeredOn: dateOpt,
  ownerId: uuidOpt3,
  expectedAmount: numOpt(1e9),
  notes: optionalString(1e3)
});
var verificationSchema = z11.object({
  source: z11.enum(MILESTONE_SOURCES, { errorMap: () => ({ message: "Say where this was confirmed" }) }),
  sourceRef: optionalString(200),
  verifiedOn: z11.coerce.date({ errorMap: () => ({ message: "Enter the date it was verified" }) }),
  verifiedById: z11.string({ required_error: "Choose who verified it" }).uuid("Choose who verified it"),
  evidenceFileId: uuidOpt3
});
var milestoneEventSchema = verificationSchema.extend({
  stageKey: z11.string().trim().toUpperCase().min(2).max(40),
  outcome: z11.enum(MILESTONE_OUTCOMES),
  eventDate: z11.coerce.date(),
  pendingDocuments: z11.array(z11.string().trim().min(1).max(120)).max(20).default([]),
  notes: optionalString(1e3)
});
var subsidyApprovalSchema = verificationSchema.extend({
  approvedAmount: z11.coerce.number().positive("Enter the approved amount").max(1e9),
  approvedOn: z11.coerce.date(),
  notes: optionalString(1e3)
});
var disbursementSchema = verificationSchema.extend({
  amount: z11.coerce.number().positive("Enter the amount received").max(1e9),
  receivedOn: z11.coerce.date(),
  reference: z11.string().trim().min(3, "Enter the UTR / transaction reference").max(80),
  notes: optionalString(500)
});
var trackerListQuerySchema = listQuerySchema.extend({
  stage: z11.string().max(40).optional(),
  ownerId: z11.string().uuid().optional(),
  stale: z11.enum(["true", "false"]).optional(),
  outstanding: z11.enum(["true", "false"]).optional()
});
var solarTrackerQuerySchema = listQuerySchema.extend({
  status: z11.string().max(20).optional(),
  projectId: z11.string().uuid().optional(),
  districtId: z11.string().uuid().optional()
});
var projectCloseSchema = z11.object({
  /** Needed (with the override permission) when some checks fail. */
  overrideReason: optionalString(1e3)
});

// src/schemas/telecom.ts
import { z as z12 } from "zod";
var uuidOpt4 = z12.string().uuid().nullable().optional();
var dateOpt2 = z12.coerce.date().nullable().optional();
var hsn = z12.string().trim().regex(/^\d{4,8}$/, "HSN/SAC is 4 to 8 digits").nullable().optional().or(z12.literal("").transform(() => null));
var WORK_ORDER_STATUSES = ["DRAFT", "ACTIVE", "COMPLETED", "CLOSED", "CANCELLED"];
var WORK_ORDER_STATUS_LABELS = { DRAFT: "Draft", ACTIVE: "Active", COMPLETED: "Work complete", CLOSED: "Closed", CANCELLED: "Cancelled" };
var BILLING_TRIGGERS = ["MANUAL", "SITE_COMPLETED", "CLIENT_ACCEPTED"];
var BILLING_TRIGGER_LABELS = { MANUAL: "Marked ready by the team", SITE_COMPLETED: "When the site is completed", CLIENT_ACCEPTED: "When the client accepts the site" };
var DISPATCH_STATUSES = ["IN_TRANSIT", "DELIVERED", "SHORT_DELIVERED"];
var DISPATCH_STATUS_LABELS = { IN_TRANSIT: "In transit", DELIVERED: "Delivered", SHORT_DELIVERED: "Delivered with shortage" };
var SHORTAGE_RESOLUTIONS = ["RETURNED_TO_STORE", "WRITTEN_OFF", "REDISPATCHED"];
var SHORTAGE_RESOLUTION_LABELS = { RETURNED_TO_STORE: "Came back to store", WRITTEN_OFF: "Lost in transit (written off)", REDISPATCHED: "Sent again" };
var COMPLETION_STATUSES = ["SUBMITTED", "ACCEPTED", "REJECTED"];
var COMPLETION_STATUS_LABELS = { SUBMITTED: "Submitted to client", ACCEPTED: "Accepted by client", REJECTED: "Rejected by client" };
var DEDUCTION_TYPES = ["TDS", "PENALTY", "OTHER"];
var DEDUCTION_TYPE_LABELS = { TDS: "TDS deducted", PENALTY: "Penalty / LD", OTHER: "Other deduction" };
var DEDUCTION_STATUSES = ["CLAIMED", "SETTLED", "DISPUTED", "WITHDRAWN"];
var DEDUCTION_STATUS_LABELS = { CLAIMED: "Deducted by client", SETTLED: "Settled", DISPUTED: "Disputed", WITHDRAWN: "Withdrawn by client" };
var SUBMISSION_MODES = ["PORTAL", "EMAIL", "COURIER", "HAND"];
var SUBMISSION_MODE_LABELS = { PORTAL: "Client portal", EMAIL: "Email", COURIER: "Courier", HAND: "By hand" };
var SUBMISSION_STATUSES = ["SUBMITTED", "ACKNOWLEDGED", "QUERY", "REJECTED"];
var SUBMISSION_STATUS_LABELS = { SUBMITTED: "Submitted", ACKNOWLEDGED: "Acknowledged", QUERY: "Query raised", REJECTED: "Rejected" };
var COLLECTION_ACTION_TYPES = ["CALL", "EMAIL", "VISIT", "LETTER", "ESCALATION", "OTHER"];
var COLLECTION_ACTION_LABELS = { CALL: "Call", EMAIL: "Email", VISIT: "Visit", LETTER: "Letter / notice", ESCALATION: "Escalation", OTHER: "Other" };
var telecomSettingsSchema = z12.object({
  /** Conversion stages a telecom site moves through (shown on the telecom tracker). */
  conversionStages: z12.array(z12.object({ key: z12.string().trim().toUpperCase().regex(/^[A-Z0-9_]{2,40}$/, "Use capital letters, digits and underscores"), label: z12.string().trim().min(2).max(120) })).min(1).max(30).refine((xs) => new Set(xs.map((x) => x.key)).size === xs.length, "Stage keys must be unique").default([
    { key: "ACCESS", label: "Site access / permissions" },
    { key: "MATERIAL", label: "Material at site" },
    { key: "CIVIL", label: "Civil and foundation work" },
    { key: "ERECTION", label: "Structure / pole erection" },
    { key: "INSTALLATION", label: "Equipment installation" },
    { key: "POWER", label: "Power and cabling" },
    { key: "TESTING", label: "Testing and integration" },
    { key: "ACCEPTANCE", label: "Client acceptance" }
  ]),
  defaultRetentionPercent: z12.coerce.number().min(0).max(20).default(5),
  /** Days after an invoice is posted before its retention falls due for release. */
  defaultRetentionReleaseDays: z12.coerce.number().int().min(0).max(1825).default(365)
});
var workOrderLineSchema = z12.object({
  id: uuidOpt4,
  itemId: uuidOpt4,
  /** Client's schedule-of-rates code. */
  clientCode: optionalString(40),
  description: z12.string().trim().min(2, "Describe the work").max(500),
  uom: z12.string().trim().min(1).max(10),
  rate: z12.coerce.number().min(0).max(1e9),
  /** Contracted quantity; empty for open-ended rate items. */
  qty: z12.coerce.number().positive().max(1e7).nullable().optional(),
  hsnSac: hsn,
  gstRate: z12.coerce.number().min(0).max(100)
});
var workOrderSchema = z12.object({
  projectId: z12.string().uuid({ message: "Choose a telecom project" }),
  clientWoNumber: z12.string().trim().min(2, "Enter the client\u2019s work order / PO number").max(60),
  woDate: z12.coerce.date(),
  validUntil: dateOpt2,
  scope: optionalString(4e3),
  contractValue: z12.coerce.number().min(0).max(1e11).nullable().optional(),
  retentionPercent: z12.coerce.number().min(0).max(20).default(0),
  retentionReleaseDays: z12.coerce.number().int().min(0).max(1825).default(365),
  paymentTermsDays: z12.coerce.number().int().min(0).max(365).default(30),
  billingTerms: optionalString(2e3),
  lines: z12.array(workOrderLineSchema).max(500).default([])
}).refine((v) => !v.validUntil || v.validUntil >= v.woDate, { path: ["validUntil"], message: "Must be on or after the work order date" });
var workOrderListQuerySchema = listQuerySchema.extend({
  status: z12.enum([...WORK_ORDER_STATUSES, "ALL", "OPEN"]).default("OPEN"),
  projectId: z12.string().uuid().optional(),
  telecomClientId: z12.string().uuid().optional()
});
var workOrderSitesSchema = z12.object({ siteIds: z12.array(z12.string().uuid()).max(500) });
var billingMilestonePlanSchema = z12.object({
  label: z12.string().trim().min(2).max(200),
  siteId: uuidOpt4,
  basis: z12.enum(["PERCENT", "AMOUNT"]),
  percent: z12.coerce.number().min(0).max(100).nullable().optional(),
  amount: z12.coerce.number().min(0).max(1e11).nullable().optional(),
  trigger: z12.enum(BILLING_TRIGGERS).default("MANUAL"),
  hsnSac: hsn,
  gstRate: z12.coerce.number().min(0).max(100).default(18)
}).refine((v) => v.basis === "PERCENT" ? v.percent != null && v.percent > 0 : v.amount != null && v.amount > 0, { path: ["amount"], message: "Enter the percentage or amount" });
var stageEventSchema = z12.object({
  stageKey: z12.string().trim().toUpperCase().min(2).max(40),
  eventDate: z12.coerce.date(),
  notes: optionalString(1e3)
});
var dispatchLineSchema = z12.object({
  itemId: z12.string().uuid({ message: "Choose an item" }),
  qty: z12.coerce.number().positive("Quantity must be more than zero").max(1e7),
  serialIds: z12.array(z12.string().uuid()).max(5e3).default([]),
  batchId: uuidOpt4
});
var dispatchSchema = z12.object({
  siteId: z12.string().uuid({ message: "Choose the site" }),
  workOrderId: uuidOpt4,
  fromLocationId: z12.string().uuid({ message: "Choose the store dispatching the material" }),
  dispatchDate: z12.coerce.date(),
  vehicleNo: optionalString(20),
  driverName: optionalString(120),
  driverPhone: optionalString(20),
  transporter: optionalString(120),
  lrNumber: optionalString(60),
  ewayBillNo: optionalString(20),
  notes: optionalString(1e3),
  lines: z12.array(dispatchLineSchema).min(1, "Add at least one item").max(200)
});
var deliverySchema = z12.object({
  receivedOn: z12.coerce.date(),
  receivedByName: z12.string().trim().min(2, "Who received the material?").max(120),
  receivedByPhone: optionalString(20),
  remarks: optionalString(1e3),
  lines: z12.array(z12.object({ dispatchLineId: z12.string().uuid(), qtyReceived: z12.coerce.number().min(0).max(1e7), shortageReason: optionalString(300) })).min(1).max(200)
});
var shortageResolutionSchema = z12.object({
  resolution: z12.enum(SHORTAGE_RESOLUTIONS),
  notes: z12.string().trim().min(3, "Explain what happened").max(1e3),
  /** Store receiving the material when it came back. */
  toLocationId: uuidOpt4,
  /** Serial numbers that came back (serialised items). */
  serialIds: z12.array(z12.string().uuid()).max(5e3).default([])
});
var dispatchListQuerySchema = listQuerySchema.extend({
  status: z12.enum([...DISPATCH_STATUSES, "ALL", "SHORTAGES"]).default("ALL"),
  siteId: z12.string().uuid().optional(),
  workOrderId: z12.string().uuid().optional()
});
var siteCompletionSchema = z12.object({
  completedOn: z12.coerce.date(),
  acceptanceRef: optionalString(80),
  clientRepName: optionalString(120),
  clientRepDesignation: optionalString(120),
  remarks: optionalString(1e3)
});
var completionDecisionSchema = z12.object({
  decision: z12.enum(["ACCEPTED", "REJECTED"]),
  decidedOn: z12.coerce.date(),
  clientRepName: z12.string().trim().min(2, "Who signed for the client?").max(120),
  clientRepDesignation: optionalString(120),
  acceptanceRef: optionalString(80),
  remarks: optionalString(1e3)
});
var quantityBillSchema = z12.object({
  docDate: z12.coerce.date(),
  lines: z12.array(z12.object({ woLineId: z12.string().uuid(), siteId: z12.string().uuid(), qty: z12.coerce.number().positive("Quantity must be more than zero").max(1e7) })).min(1, "Choose quantities to bill").max(500)
});
var milestoneBillSchema = z12.object({
  docDate: z12.coerce.date(),
  milestoneIds: z12.array(z12.string().uuid()).min(1, "Choose milestones to bill").max(100)
});
var deductionSchema = z12.object({
  type: z12.enum(DEDUCTION_TYPES),
  amount: z12.coerce.number().positive("Enter the amount deducted").max(1e11),
  reason: z12.string().trim().min(3, "Give the reason").max(500),
  reference: optionalString(80)
});
var deductionStatusSchema = z12.object({
  status: z12.enum(["SETTLED", "DISPUTED", "WITHDRAWN"]),
  notes: z12.string().trim().min(3, "Explain").max(1e3),
  /** Credit note or TDS receipt that settled it. */
  settledByDocId: uuidOpt4
});
var retentionReleaseSchema = z12.object({
  releasedOn: z12.coerce.date(),
  amount: z12.coerce.number().positive().max(1e11),
  notes: optionalString(500)
});
var submissionSchema = z12.object({
  submittedOn: z12.coerce.date(),
  mode: z12.enum(SUBMISSION_MODES),
  reference: optionalString(80),
  notes: optionalString(500)
});
var submissionUpdateSchema = z12.object({
  status: z12.enum(["ACKNOWLEDGED", "QUERY", "REJECTED"]),
  on: z12.coerce.date(),
  notes: optionalString(500)
});
var collectionActionSchema = z12.object({
  customerId: z12.string().uuid({ message: "Choose the customer" }),
  invoiceId: uuidOpt4,
  actionDate: z12.coerce.date(),
  type: z12.enum(COLLECTION_ACTION_TYPES),
  notes: z12.string().trim().min(3, "What was said or done?").max(2e3),
  promisedOn: dateOpt2,
  promisedAmount: z12.coerce.number().positive().max(1e11).nullable().optional(),
  nextActionOn: dateOpt2,
  ownerId: uuidOpt4
});
var collectionsQuerySchema = listQuerySchema.extend({
  workOrderId: z12.string().uuid().optional(),
  customerId: z12.string().uuid().optional(),
  overdue: z12.enum(["true", "false"]).optional(),
  actionDue: z12.enum(["true", "false"]).optional()
});
var telecomTrackerQuerySchema = listQuerySchema.extend({
  workOrderId: z12.string().uuid().optional(),
  stage: z12.string().max(40).optional(),
  status: z12.string().max(20).optional()
});

// src/schemas/finance.ts
import { z as z13 } from "zod";
var uuidOpt5 = z13.string().uuid().nullable().optional();
var money3 = (label) => z13.coerce.number({ invalid_type_error: label }).min(0).max(1e11);
var EXPENSE_SCOPES = ["DIRECT", "OVERHEAD"];
var EXPENSE_SCOPE_LABELS = { DIRECT: "Project / site cost", OVERHEAD: "Administrative overhead" };
var COST_STATUSES = ["DRAFT", "PENDING_APPROVAL", "APPROVED", "REJECTED", "CANCELLED"];
var COST_STATUS_LABELS = { DRAFT: "Draft", PENDING_APPROVAL: "Pending approval", APPROVED: "Approved", REJECTED: "Returned", CANCELLED: "Cancelled" };
var LABOUR_BASES = ["DAYS", "PERCENT"];
var LABOUR_BASIS_LABELS = { DAYS: "Days worked", PERCENT: "Share of the month" };
var REFERRAL_STATUSES = ["PROPOSED", "APPROVED", "PAID", "CANCELLED"];
var REFERRAL_STATUS_LABELS = { PROPOSED: "Proposed", APPROVED: "Approved", PAID: "Paid", CANCELLED: "Cancelled" };
var OVERHEAD_BASES = ["REVENUE", "DIRECT_COST", "CAPACITY_KW", "EQUAL"];
var OVERHEAD_BASIS_LABELS = {
  REVENUE: "Recognised revenue in the period",
  DIRECT_COST: "Direct cost in the period",
  CAPACITY_KW: "Capacity (kW) of active solar projects",
  EQUAL: "Equally across active projects"
};
var OVERHEAD_STATUSES = ["DRAFT", "ALLOCATED"];
var CHANGE_ORDER_STATUSES = ["DRAFT", "PENDING_APPROVAL", "APPROVED", "REJECTED", "CANCELLED"];
var REVENUE_POLICIES = ["ON_INVOICE", "ON_RECEIPT", "MILESTONE", "PERCENT_COMPLETE"];
var REVENUE_POLICY_LABELS = {
  ON_INVOICE: "When a tax invoice is posted (net of credit/debit notes)",
  ON_RECEIPT: "When money is received (cash basis)",
  MILESTONE: "When Finance records a milestone recognition entry",
  PERCENT_COMPLETE: "Percentage of completion (cost incurred \xF7 estimated cost)"
};
var financeSettingsSchema = z13.object({
  /** Finance's chosen revenue recognition policy for project P&L. */
  revenuePolicy: z13.enum(REVENUE_POLICIES).default("ON_INVOICE"),
  /** Recognised revenue under percentage of completion never exceeds this share of contract value until the project is completed. */
  percentCompleteCap: z13.coerce.number().min(50).max(100).default(100),
  defaultOverheadBasis: z13.enum(OVERHEAD_BASES).default("REVENUE"),
  /** Expenses at or below this amount need no receipt or bill attached. */
  attachmentOptionalUpTo: z13.coerce.number().min(0).max(1e5).default(0)
});
var expenseCategorySchema = z13.object({
  code: z13.string().trim().toUpperCase().regex(/^[A-Z0-9_-]{2,20}$/, "Use capital letters, digits, - or _"),
  name: z13.string().trim().min(2).max(120),
  scope: z13.enum(EXPENSE_SCOPES),
  isActive: z13.boolean().default(true)
});
var labourRateSchema = z13.object({
  userId: z13.string().uuid({ message: "Choose the employee" }),
  costPerDay: money3("Enter the cost per day").refine((n) => n > 0, "Enter the cost per day"),
  monthlyCost: money3("Enter the monthly cost").refine((n) => n > 0, "Enter the monthly cost"),
  effectiveFrom: z13.coerce.date(),
  notes: optionalString(300)
});
var expenseSchema = z13.object({
  categoryId: z13.string().uuid({ message: "Choose a category" }),
  division: z13.enum(["SOLAR", "TELECOM"]),
  expenseDate: z13.coerce.date(),
  projectId: uuidOpt5,
  siteId: uuidOpt5,
  supplierId: uuidOpt5,
  payeeName: optionalString(150),
  billNumber: optionalString(60),
  billDate: z13.coerce.date().nullable().optional(),
  description: z13.string().trim().min(3, "Describe the expense").max(1e3),
  amount: money3("Enter the amount").refine((n) => n > 0, "Enter the amount"),
  gstAmount: money3("Enter the GST").default(0),
  /** GST that can be claimed as input credit is not part of the project cost. */
  gstClaimable: z13.boolean().default(true)
}).refine((v) => !!v.supplierId || !!v.payeeName?.trim(), { path: ["payeeName"], message: "Choose the supplier or enter who was paid" });
var expenseListQuerySchema = listQuerySchema.extend({
  status: z13.enum([...COST_STATUSES, "ALL", "OPEN"]).default("ALL"),
  projectId: z13.string().uuid().optional(),
  categoryId: z13.string().uuid().optional(),
  scope: z13.enum(EXPENSE_SCOPES).optional(),
  from: z13.coerce.date().optional(),
  to: z13.coerce.date().optional(),
  mine: z13.enum(["true", "false"]).optional()
});
var labourEntrySchema = z13.object({
  userId: z13.string().uuid({ message: "Choose the employee" }),
  projectId: z13.string().uuid({ message: "Choose the project" }),
  siteId: uuidOpt5,
  basis: z13.enum(LABOUR_BASES),
  /** DAYS: the work dates fall in this range. PERCENT: a calendar month (first day). */
  periodStart: z13.coerce.date(),
  periodEnd: z13.coerce.date(),
  quantity: z13.coerce.number().positive("Enter days or percentage").max(1e3),
  notes: optionalString(500)
}).refine((v) => v.periodEnd >= v.periodStart, { path: ["periodEnd"], message: "End must be on or after the start" }).refine((v) => v.basis !== "PERCENT" || v.quantity <= 100, { path: ["quantity"], message: "At most 100%" });
var labourListQuerySchema = listQuerySchema.extend({
  status: z13.enum([...COST_STATUSES, "ALL"]).default("ALL"),
  projectId: z13.string().uuid().optional(),
  userId: z13.string().uuid().optional()
});
var referralBonusSchema = z13.object({
  projectId: z13.string().uuid({ message: "Choose the project" }),
  partnerId: z13.string().uuid({ message: "Choose the channel partner" }),
  basis: z13.enum(["FIXED", "PERCENT"]),
  rate: z13.coerce.number().min(0).max(1e9).nullable().optional(),
  amount: money3("Enter the bonus amount").refine((n) => n > 0, "Enter the bonus amount"),
  notes: optionalString(500)
});
var referralPaymentSchema = z13.object({
  paidOn: z13.coerce.date(),
  paymentRef: z13.string().trim().min(3, "Enter the payment reference").max(80)
});
var changeOrderSchema = z13.object({
  orderDate: z13.coerce.date(),
  description: z13.string().trim().min(3, "Describe the change").max(1e3),
  /** Positive adds to the contract value, negative reduces it. */
  amount: z13.coerce.number().min(-1e11).max(1e11).refine((n) => n !== 0, "Enter the change in value"),
  customerRef: optionalString(80)
});
var projectEstimateSchema = z13.object({
  materialCost: money3("Enter the material estimate").default(0),
  labourCost: money3("Enter the labour estimate").default(0),
  otherDirectCost: money3("Enter other direct costs").default(0),
  referralCost: money3("Enter the referral estimate").default(0),
  overheadCost: money3("Enter the overhead estimate").default(0),
  notes: optionalString(1e3)
});
var revenueEntrySchema = z13.object({
  entryDate: z13.coerce.date(),
  milestone: z13.string().trim().min(3, "Name the milestone").max(200),
  amount: z13.coerce.number().min(-1e11).max(1e11).refine((n) => n !== 0, "Enter the amount"),
  notes: optionalString(500)
});
var overheadPoolSchema = z13.object({
  name: z13.string().trim().min(3).max(120),
  division: z13.enum(["SOLAR", "TELECOM"]).nullable().optional(),
  periodStart: z13.coerce.date(),
  periodEnd: z13.coerce.date(),
  basis: z13.enum(OVERHEAD_BASES),
  /** Leave empty to use approved overhead expenses of the period. */
  amount: z13.coerce.number().positive().max(1e11).nullable().optional(),
  notes: optionalString(500)
}).refine((v) => v.periodEnd >= v.periodStart, { path: ["periodEnd"], message: "End must be on or after the start" });
var pnlQuerySchema = listQuerySchema.extend({
  division: z13.enum(["SOLAR", "TELECOM"]).optional(),
  status: z13.string().max(20).optional()
});

// src/roi.ts
import { z as z14 } from "zod";
var roiScenarioSchema = z14.object({
  name: z14.string().trim().min(1).max(60),
  capacityKw: z14.coerce.number().positive().max(1e5),
  /** Total price paid for the system, including GST. */
  systemCost: z14.coerce.number().positive().max(1e10),
  /** Subsidy received by the customer (reduces the net investment). */
  subsidy: z14.coerce.number().min(0).max(1e10).default(0),
  /** Expected first-year generation per kW (kWh/kW/year). */
  yieldKwhPerKw: z14.coerce.number().positive().max(3e3).default(1450),
  /** Share of generation used on site; the rest is exported. */
  selfConsumptionPct: z14.coerce.number().min(0).max(100).default(70),
  /** Grid tariff avoided for each unit used on site (₹/kWh). */
  tariffPerKwh: z14.coerce.number().min(0).max(100),
  /** Credit for each exported unit (₹/kWh); equals the tariff under full net metering. */
  exportTariffPerKwh: z14.coerce.number().min(0).max(100),
  tariffEscalationPct: z14.coerce.number().min(-10).max(20).default(3),
  degradationPct: z14.coerce.number().min(0).max(5).default(0.5),
  omCostPerYear: z14.coerce.number().min(0).max(1e9).default(0),
  omEscalationPct: z14.coerce.number().min(0).max(20).default(5),
  years: z14.coerce.number().int().min(5).max(30).default(25)
});
var r22 = (n) => Math.round(n * 100) / 100;
function npv(rate, flows) {
  return flows.reduce((s, f, t) => s + f / Math.pow(1 + rate, t), 0);
}
function irr(flows) {
  if (!flows.some((f) => f < 0) || !flows.some((f) => f > 0)) return null;
  let lo = -0.99;
  let hi = 10;
  let fLo = npv(lo, flows);
  if (fLo * npv(hi, flows) > 0) return null;
  for (let i = 0; i < 200; i++) {
    const mid = (lo + hi) / 2;
    const fMid = npv(mid, flows);
    if (Math.abs(fMid) < 1e-7) return mid;
    if (fLo * fMid < 0) hi = mid;
    else {
      lo = mid;
      fLo = fMid;
    }
  }
  return (lo + hi) / 2;
}
function calculateRoi(input) {
  const s = roiScenarioSchema.parse(input);
  const netInvestment = Math.max(0, s.systemCost - s.subsidy);
  const selfShare = s.selfConsumptionPct / 100;
  const years = [];
  let cumulative = -netInvestment;
  let lifetimeGen = 0;
  let lifetimeNet = 0;
  let lifetimeOm = 0;
  let payback = netInvestment === 0 ? 0 : null;
  for (let y = 1; y <= s.years; y++) {
    const gen = s.capacityKw * s.yieldKwhPerKw * Math.pow(1 - s.degradationPct / 100, y - 1);
    const esc = Math.pow(1 + s.tariffEscalationPct / 100, y - 1);
    const savings = gen * selfShare * s.tariffPerKwh * esc + gen * (1 - selfShare) * s.exportTariffPerKwh * esc;
    const om = s.omCostPerYear * Math.pow(1 + s.omEscalationPct / 100, y - 1);
    const net = savings - om;
    const before = cumulative;
    cumulative += net;
    if (payback === null && before < 0 && cumulative >= 0 && net > 0) payback = y - 1 + -before / net;
    lifetimeGen += gen;
    lifetimeNet += net;
    lifetimeOm += om;
    years.push({ year: y, generationKwh: Math.round(gen), savings: r22(savings), omCost: r22(om), netCashFlow: r22(net), cumulative: r22(cumulative) });
  }
  const rate = irr([-netInvestment, ...years.map((y) => y.netCashFlow)]);
  return {
    name: s.name,
    netInvestment: r22(netInvestment),
    firstYearGenerationKwh: years[0].generationKwh,
    firstYearSavings: years[0].savings,
    lifetimeGenerationKwh: Math.round(lifetimeGen),
    lifetimeNetSavings: r22(lifetimeNet),
    netGain: r22(lifetimeNet - netInvestment),
    paybackYears: payback === null ? null : Math.round(payback * 10) / 10,
    roiPct: netInvestment > 0 ? r22((lifetimeNet - netInvestment) / netInvestment * 100) : null,
    irrPct: rate === null ? null : r22(rate * 100),
    costPerKwh: lifetimeGen > 0 ? r22((netInvestment + lifetimeOm) / lifetimeGen) : null,
    years
  };
}
var ROI_DISCLAIMER = "Estimates for comparison only, not a guarantee. Actual generation and savings depend on weather, shading, orientation, maintenance, grid availability and future tariffs.";

// src/schemas/ai.ts
import { z as z15 } from "zod";
var copilotAskSchema = z15.object({
  question: z15.string().trim().min(3, "Ask a question").max(1e3),
  /** Continue an earlier conversation (its id is returned with every answer). */
  conversationId: z15.string().uuid().nullable().optional()
});
var COPILOT_CONFIDENCE = ["HIGH", "MEDIUM", "LOW"];
var dprSummarySchema = z15.object({
  siteId: z15.string().uuid().nullable().optional(),
  projectId: z15.string().uuid().nullable().optional(),
  from: z15.coerce.date(),
  to: z15.coerce.date()
}).refine((v) => !!v.siteId || !!v.projectId, { path: ["siteId"], message: "Choose a site or a project" }).refine((v) => v.to >= v.from, { path: ["to"], message: "End must be on or after the start" }).refine((v) => v.to.getTime() - v.from.getTime() <= 92 * 864e5, { path: ["to"], message: "Summarise at most three months at a time" });
var bomApplySchema = z15.object({
  requestId: z15.string().uuid().nullable().optional(),
  lines: z15.array(
    z15.object({
      itemId: z15.string().uuid(),
      qty: z15.coerce.number().positive().max(1e7),
      notes: z15.string().trim().max(500).nullable().optional()
    })
  ).min(1, "Choose at least one line").max(300)
});
var roiCompareSchema = z15.object({
  scenarios: z15.array(roiScenarioSchema).min(1).max(4)
});
var shortagePrSchema = z15.object({
  division: z15.enum(["SOLAR", "TELECOM"]),
  lines: z15.array(z15.object({ itemId: z15.string().uuid(), qty: z15.coerce.number().positive().max(1e7), remarks: z15.string().trim().max(500).nullable().optional() })).min(1, "Choose at least one item").max(200),
  notes: z15.string().trim().max(1e3).nullable().optional()
});
export {
  ACTIVITY_OUTCOMES,
  ACTIVITY_TYPES,
  ACTIVITY_TYPE_LABELS,
  ADDRESS_TYPES,
  AGEING_BUCKETS,
  AI_DEFAULT_MODEL,
  AI_FEATURES,
  AI_FEATURE_LABELS,
  AI_PROVIDERS,
  AI_PROVIDER_LABELS,
  ALL_PERMISSION_KEYS,
  APPROVAL_STATUS,
  AUDIT_ACTIONS,
  BILLING_TRIGGERS,
  BILLING_TRIGGER_LABELS,
  BLOCK_TYPE_LABELS,
  BONUS_TYPES,
  CHANGE_ORDER_STATUSES,
  CHECKLIST_ITEM_TYPES,
  CHECKLIST_KINDS,
  CHECKLIST_KINDS_BY_DIVISION,
  CHECKLIST_KIND_LABELS,
  COLLECTION_ACTION_LABELS,
  COLLECTION_ACTION_TYPES,
  COMPLETION_STATUSES,
  COMPLETION_STATUS_LABELS,
  COPILOT_CONFIDENCE,
  COST_STATUSES,
  COST_STATUS_LABELS,
  CUSTOMER_TYPES,
  DEDUCTION_STATUSES,
  DEDUCTION_STATUS_LABELS,
  DEDUCTION_TYPES,
  DEDUCTION_TYPE_LABELS,
  DEFECT_SEVERITIES,
  DEFECT_STATUSES,
  DESIGN_STATUSES,
  DESIGN_STATUS_LABELS,
  DISPATCH_STATUSES,
  DISPATCH_STATUS_LABELS,
  DIVISIONS,
  DOCUMENT_TYPES,
  DPR_STATUSES,
  DPR_STATUS_LABELS,
  Decimal,
  EXPENSE_SCOPES,
  EXPENSE_SCOPE_LABELS,
  IMPORT_MAX_ROWS,
  IMPORT_PERMISSIONS,
  IMPORT_TYPES,
  IMPORT_TYPE_KEYS,
  INDIAN_STATES,
  ITEM_TYPES,
  LABOUR_BASES,
  LABOUR_BASIS_LABELS,
  LEAD_PIPELINE,
  LEAD_STATUSES,
  LEAD_STATUS_LABELS,
  LEG_HEIGHTS,
  LINE_TYPES,
  LINE_TYPE_LABELS,
  LOCATION_TYPES,
  LOCATION_TYPE_LABELS,
  MILESTONE_OUTCOMES,
  MILESTONE_OUTCOME_LABELS,
  MILESTONE_SOURCES,
  MILESTONE_SOURCE_LABELS,
  MILESTONE_STATUSES,
  MILESTONE_STATUS_LABELS,
  MOVEMENT_TYPE_LABELS,
  NOTE_REASONS,
  NOTE_REASON_LABELS,
  OVERHEAD_BASES,
  OVERHEAD_BASIS_LABELS,
  OVERHEAD_STATUSES,
  PAGE_KINDS,
  PAGE_KIND_LABELS,
  PAGE_LAYOUTS,
  PARTNER_TYPES,
  PASSWORD_MIN_LENGTH,
  PAYMENT_MODES,
  PAYMENT_MODE_LABELS,
  PERMISSIONS,
  PERMISSION_CATALOGUE,
  PHASES,
  PRIORITIES,
  PROCUREMENT_STATUSES,
  PROCUREMENT_STATUS_LABELS,
  PROJECT_STATUSES,
  PROJECT_STATUS_LABELS,
  PROPOSAL_SECTIONS,
  PROPOSAL_SECTION_LABELS,
  PROPOSAL_STATUSES,
  PROPOSAL_STATUS_LABELS,
  PROPOSAL_TOKENS,
  REFERRAL_STATUSES,
  REFERRAL_STATUS_LABELS,
  REUSABLE_CATEGORIES,
  REVENUE_POLICIES,
  REVENUE_POLICY_LABELS,
  ROI_DISCLAIMER,
  ROLE_CODES,
  ROOF_CONDITIONS,
  ROOF_CONDITION_LABELS,
  ROOF_TYPES,
  ROOF_TYPE_LABELS,
  SALES_DOC_PATHS,
  SALES_DOC_STATUSES,
  SALES_DOC_STATUS_LABELS,
  SALES_DOC_TITLES,
  SALES_DOC_TYPES,
  SALES_DOC_TYPE_LABELS,
  SHORTAGE_RESOLUTIONS,
  SHORTAGE_RESOLUTION_LABELS,
  SITE_STATUSES,
  SITE_STATUS_LABELS,
  SOLAR_TYPES,
  SOLAR_TYPE_LABELS,
  STOCK_DOC_PATHS,
  STOCK_DOC_SERIES,
  STOCK_DOC_STATUSES,
  STOCK_DOC_STATUS_LABELS,
  STOCK_DOC_TYPES,
  STOCK_DOC_TYPE_LABELS,
  SUBMISSION_MODES,
  SUBMISSION_MODE_LABELS,
  SUBMISSION_STATUSES,
  SUBMISSION_STATUS_LABELS,
  SUBSIDY_AMOUNT_STAGE,
  SUPPLY_TYPES,
  SUPPLY_TYPE_LABELS,
  SURVEY_MISSING_INFO,
  SURVEY_STATUSES,
  SURVEY_STATUS_LABELS,
  SYSTEM_ACTIVITY_TYPES,
  SYSTEM_ROLES,
  TAX_MODES,
  TAX_MODE_LABELS,
  TOKEN_PATTERN,
  TRACKER_KINDS,
  UPLOAD_MIME_OPTIONS,
  VERSION_STATUSES,
  WORK_ORDER_STATUSES,
  WORK_ORDER_STATUS_LABELS,
  activitySchema,
  adminResetPasswordSchema,
  ageingBucket,
  aiDraftRequestSchema,
  aiExtractRequestSchema,
  aiRequestListSchema,
  aiSettingsSchema,
  aiSettingsUpdateSchema,
  allocateSchema,
  allocationInputSchema,
  amountInWords,
  approvalDecisionSchema,
  approvalRejectSchema,
  approvalRuleSchema,
  auditQuerySchema,
  billingLineSchema,
  billingMilestonePlanSchema,
  billingMilestoneSchema,
  billingSettingsSchema,
  blockSchema,
  bomApplySchema,
  bomBlock,
  bomFromDocSchema,
  bomLineSchema,
  bomReplaceSchema,
  branchSchema,
  calculateRoi,
  campaignSchema,
  changeOrderSchema,
  changePasswordSchema,
  channelPartnerSchema,
  chartBlock,
  checklistItemUpdateSchema,
  checklistTemplateItemSchema,
  checklistTemplateSchema,
  collectionActionSchema,
  collectionsQuerySchema,
  companyProfileSchema,
  completeFollowUpSchema,
  completionDecisionSchema,
  complianceRuleSchema,
  computeGst,
  contactSchema,
  convertDocSchema,
  convertLeadSchema,
  copilotAskSchema,
  createProposalSchema,
  createUserSchema,
  crewSchema,
  crmSettingsSchema,
  customerAddressSchema,
  customerListQuerySchema,
  customerSchema,
  deductionSchema,
  deductionStatusSchema,
  defectSchema,
  deliverySchema,
  designMaterialLineSchema,
  designSchema,
  disbursementSchema,
  discomApplicationSchema,
  discomSchema,
  dispatchLineSchema,
  dispatchListQuerySchema,
  dispatchSchema,
  districtSchema,
  dividerBlock,
  docCancelSchema,
  docDecisionSchema,
  docRejectSchema,
  dprLineSchema,
  dprListQuerySchema,
  dprSchema,
  dprSummarySchema,
  duplicateCheckSchema,
  duplicatePageSchema,
  emailDocSchema,
  executionPlanSchema,
  executionSettingsSchema,
  expenseCategorySchema,
  expenseListQuerySchema,
  expenseSchema,
  fillTokens,
  financeSettingsSchema,
  financialYearBounds,
  financialYearCodeFor,
  financialYearSchema,
  followUpListQuerySchema,
  followUpSchema,
  forgotPasswordSchema,
  formatDocumentNumber,
  formatINR,
  formatIndianNumber,
  goodsReceiptSchema,
  grnLineSchema,
  grnListQuerySchema,
  gstStateCode,
  gstinCheckChar,
  headingBlock,
  hsnSacSchema,
  imageBlock,
  importMappingSchema,
  importSignOffSchema,
  insertPageSchema,
  inventorySettingsSchema,
  irr,
  isValidGstin,
  itemCategorySchema,
  itemComplianceDocSchema,
  itemListQuerySchema,
  itemSchema,
  keyValueBlock,
  labourEntrySchema,
  labourListQuerySchema,
  labourRateSchema,
  leadAssignSchema,
  leadListQuerySchema,
  leadSchema,
  leadSourceSchema,
  leadStatusChangeSchema,
  ledgerQuerySchema,
  listQuerySchema,
  locationSchema,
  loginSchema,
  masterListQuerySchema,
  measurementSchema,
  mfaCodeSchema,
  mfaDisableSchema,
  milestoneBillSchema,
  milestoneEventSchema,
  milestoneSchema,
  newVersionSchema,
  noteSchema,
  notificationTemplateSchema,
  numberSeriesSchema,
  optionalPhone,
  optionalString,
  overheadPoolSchema,
  pageBulkSchema,
  pageContentSchema,
  passwordSchema,
  paymentMilestoneSchema,
  paymentScheduleBlock,
  phoneSchema,
  pincodeSchema,
  pnlQuerySchema,
  poLineSchema,
  prLineSchema,
  priceListItemSchema,
  priceListItemsSchema,
  priceListSchema,
  priceProposal,
  pricingBlock,
  pricingGuardrails,
  pricingSchema,
  procurementListQuerySchema,
  productCardBlock,
  proformaSchema,
  projectCloseSchema,
  projectEstimateSchema,
  projectListQuerySchema,
  projectSchema,
  projectStatusSchema,
  proposalDecisionSchema,
  proposalLineSchema,
  proposalListQuerySchema,
  proposalResponseSchema,
  proposalSettingsSchema,
  purchaseOrderSchema,
  purchaseRequestSchema,
  quantityBillSchema,
  quotationOutcomeSchema,
  quotationSchema,
  receiptListQuerySchema,
  receiptSchema,
  referralBonusSchema,
  referralPaymentSchema,
  reorderPagesSchema,
  reservationSchema,
  resetPasswordSchema,
  retentionReleaseSchema,
  reusableBlockSchema,
  revenueEntrySchema,
  reverseReceiptSchema,
  richTextBlock,
  roiCompareSchema,
  roiScenarioSchema,
  roleSchema,
  roundMoney,
  salesDocListQuerySchema,
  securitySettingsSchema,
  shareProposalSchema,
  shortagePrSchema,
  shortageResolutionSchema,
  signatureBlock,
  siteAssetSchema,
  siteCompletionSchema,
  siteListQuerySchema,
  siteSchema,
  siteStatusSchema,
  solarTrackerQuerySchema,
  spacerBlock,
  stageEventSchema,
  stateFromGstin,
  stateLabel,
  statementQuerySchema,
  stockDocLineSchema,
  stockDocListQuerySchema,
  stockDocSchema,
  stockQuerySchema,
  submissionSchema,
  submissionUpdateSchema,
  subsidyApplicationSchema,
  subsidyApprovalSchema,
  supplierSchema,
  surveySchema,
  tableBlock,
  taxInvoiceSchema,
  taxRateSchema,
  taxRuleSchema,
  telecomClientSchema,
  telecomSettingsSchema,
  telecomTrackerQuerySchema,
  templatePagesSchema,
  templateSchema,
  trackerListQuerySchema,
  uomSchema,
  updateCustomerSchema,
  updateLeadSchema,
  updateNumberSeriesSchema,
  updatePageSchema,
  updateProfileSchema,
  updateProposalSchema,
  updateRoleSchema,
  updateUserSchema,
  uploadSettingsSchema,
  userListQuerySchema,
  uuid,
  verificationSchema,
  workOrderLineSchema,
  workOrderListQuerySchema,
  workOrderSchema,
  workOrderSitesSchema
};
